/**
 * Page-specific Javascript file.  Should generally be included as a separate asset bundle in your page template.
 * example: {{ assets.js('js/pages/sign-in-or-register') | raw }}
 *
 * This script depends on widgets/users.js, uf-table.js, moment.js, handlebars-helpers.js
 *
 * Target page: /users
 */
var gAssetPrefix = '/assets-raw/tactiqs/assets/sailcast';
// var gAssetPrefix = 'https://s3-us-west-2.amazonaws.com/cdn-tactiqs-io/web';

var kDegToRad = 0.01745329252;

var kRenderMaxFps = 30.0;
var kCameraModeInit = "INIT";
var kCameraModeBevGeo = 'BEV-GEO';
var kCameraModeBevWind = 'BEV-WIND';
var kCameraModeChase = 'CHASE';
var kCameraPlaneGeoDistance = 16.0; /// 16.0
var kCameraPlaneHeightDistance = 18.0;
var kCameraPlaneChaseDistance = 10.0;
var kCameraLookAtOffset = 1.0;
var kCameraFovBev = 30;
var kCameraFovChase = 90;
var kOceanSize = 36;
var kEgoScaleBev = 3.0;
var kEgoFullSizeFactor = 0.02;
var kMarkConeRadius = 0.04;
var kMarkConeHeight = 0.08;
var kMarkScaleBev = 2.5;
var kTrailColors = [ 0xe0e0e0, 0xd6ff00, 0x00e0ff, 0x1cff00, 0xff3600, 0xce00ff ];
var kNextMarkIsReaching = 0;
var kNextMarkIsUpwind = 1;
var kNextMarkIsDownwind = 2;

/* ==============================================================
   GLOBALS
   ============================================================== */
var gWindowWidth = $(window).width();
var gGoogleMapsLoaded = false;
var gMarks = null;
var gMarkCones = null;
var gMarkAnnotations = null;
var gReferenceMarkListIndex = 0;
var gFirstMarkRaceTimeOffset = 0;
var gLegs = null;
var gMarkAnnotationOffset = 0.6;
var gMarkScale = kMarkScaleBev;
var gMarksLoaded = false;
var gStartingLine = null;
var gStartingLineMaterialPre = new THREE.LineBasicMaterial( { color: 0xf00000, linewidth: 5.0 } );
var gStartingLineMaterialPost = new THREE.LineBasicMaterial( { color: 0x00f000, linewidth: 5.0 } );
var gGeoBox = null;
var gLatScale = 1.0;
var gLonScale = 1.0;
var centerLat;
var centerLon;
var gBoatIdList;
var gRecords;
var gPlaybackTime = 0.0;
var gPlaybackSpeed = 2.0;
var gPlaybackIndex;
var gRaceTimer = 100;
var gNumRecords;
var gLeaderBoard = null;
var gLeaderCalculationHold = false;

var gScene = null;
var gCamera;
var gCameraMode = kCameraModeInit;
var gRenderer;
var gRenderInterval = 1.0 / kRenderMaxFps;
var gRenderMeasuredInterval = 0;
var gBoats;
var gEgoScale = kEgoScaleBev;
var gBoatTrails;
var gBoatTrailInterval = 15;
var gBoatTrailSpotSize = 0.009;
var gBoatTrailSize = 100;
var gBoatTrailIndex;
var gBoatAnnotations;
var gBoatAnnotationOffset = 0;
var gBoatChaseDistance = kCameraPlaneChaseDistance;
var gSelectedBoatPos;
var gHdmDampTime = 100;
var gHdmAvgPerBoat = new Array();
var gEgoModel;
var gWindIndRing = null;
var gWindIndAvg = null;
var gWindIndCurrent = null;
var gWindIndAvgValue = 0;
var gWindIndCurrentValue = 0;
var gWindSpeedFont = null;
var gWindSpeedText = null;
var gWindSpeedUnit = null;
var gLaylines = null;
var gLaylineMaterial = new THREE.LineBasicMaterial( { color: 0xfcbf07, linewidth: 1.5 } );
var gLadderLines = new Array();
var gLadderLinesMaterial = new THREE.LineBasicMaterial( { color: 0xa0a0a0 } );
var gTrackline = null;
var gTracklineMaterial = new THREE.LineDashedMaterial( { color: 0xfcbf07, linewidth: 4.0, scale: 10, dashSize: 1, gapSize: 1  } );
var gTrackLineMark = null;
var gWaterLevel = 2.2;
var gCourseLevel = gWaterLevel + 0.001;
var gLaylineLevel = gWaterLevel + 0.004;
var gGeoOverlayLevel = gWaterLevel + 0.01;
var gWindIndLevel = gWaterLevel + 0.015;
var water = null;
var gVector = new THREE.Vector3();
var time = 0;
var renderClock = new THREE.Clock();

// Boat tracking data for wind overlay
var gTwdDampTime = 10;
var gTwdCameraDampTime = 600;
var gTwdAvg = mvutils_avg360_init( numBoats );
var gTwdDisplayAvg = mvutils_avg360_init( gTwdDampTime * Math.round(gPlaybackSpeed) );
var gTwdCameraAvg = mvutils_avg360_init( gTwdCameraDampTime * Math.round(gPlaybackSpeed) );
var gTwd = 0;
var gTws = 0;
var gTwaTgt = 0;
var gTwaTgtUp = 40.0;
var gTwaTgtUpAvg = mvutils_avg360_init( gTwdDampTime * Math.round(gPlaybackSpeed) );
var gTwaTgtDown = 155.0;
var gTwaTgtDownAvg = mvutils_avg360_init( gTwdDampTime * Math.round(gPlaybackSpeed) );
var gTwaTgtPointOfSail = kNextMarkIsReaching;
var gNextMarkHDT = 0;
var gXName = '';
var gLaylineLength = 5.0;
var gSelectedBoatIndex = 0;

// Replay controls
var gReplayScrubber = document.getElementById("replay-scrubber");
var gReplayScrubberStops = new Array();
var gReplayActive = false;
var gRaceStartTime;
var gRaceDuration;
var gRaceStartOffset = new Array();
var gAllElementsLoaded = false;
var gAllLogsLoaded = false;
var gGeoTexturesLoaded = false;
var gOceanTexturesLoaded = false;
var gDemoMode = false;

// Race media photo masonry
var gMediaPhotoTimelineHeight = 0;
var gPhotoTimelineAnimationInterval = 0;
//var gMediaMinColWidth = 128;
//var gMediaRoots;


/* ==============================================================
   ENTRY POINT
   ============================================================== */
function loadView( demo )
{
    gDemoMode = demo;

    if ( !demo )
    {
        $("#alerts-page").ufAlerts('clear');
    }

    $('#loading-data-alert').show();

    if ( loadRaceData() )
    {
        // Initialize target TWA averages
        mvutils_avg360_add( gTwaTgtUpAvg, gTwaTgtUp );
        mvutils_avg360_add( gTwaTgtDownAvg, gTwaTgtDown );

        loadScene();

        downloadRaceData( demo );
    }
    else
    {
        // Need to show an alert that no race info is available
    }

    // Event listener for the seek bar
    gReplayScrubber.min = 0;
    gReplayScrubber.max = 1000;
    gReplayScrubber.step = 0.1;
    gReplayScrubber.addEventListener("input", function() {

        // Stop the auto-play
        replayPause();

        // Calculate the new time
        var racetime = gRaceDuration * ( gReplayScrubber.value / 1000.0 );

        // Update the video time
        replaySkipTo( racetime );
    });

    // Pause the playback when the slider handle is being dragged
    gReplayScrubber.addEventListener("mousedown", function() {
        replayPause();
    });

    // Play the playback when the slider handle is dropped
    gReplayScrubber.addEventListener("mouseup", function() {
        replayResume();
    });
    gReplayScrubber.addEventListener("touchend", function() {
        replayResume();
    });

    // Reload the scene if the window changed
    if ( browserIsMobile === 0 )
    {
        $(window).resize(function () {
            layoutContainer();
            layoutPlayerView();
        });
    }
    else
    {
        // On mobile only use the width change to trigger a reload.
        // The height changes when the browser bar is hidden automatically.
        $(window).resize(function () {
            if ( $(window).width() !== gWindowWidth )
            {
                gWindowWidth = $(window).width();
                layoutContainer();
                layoutPlayerView();
            }
        });
    }

    $('#scene-camera-toggle').css( 'background-image', 'url("' + gAssetPrefix + '/img/ic-cam-north.png"');
}

function gSailCastSizeNotification()
{
    // Make sure the layout loop is done before we use the current DIV sizes
    setTimeout( function() {
        layoutPlayerView();
    }, 500 );
}

/* ==============================================================
   VIEW LAYOUT
   ============================================================== */
function scrollViewForMobile()
{
    if ( browserIsMobile !== 0 || originatorIsApp === 1 )
    {
        console.log('Adjusting for mobile');

        // Collapse the side bar
        if ( $('body,html').hasClass('sidebar-collapse') === false )
        {
            $('.sidebar-toggle').click()
        }

        // Scroll past the header to maximize viewing area in landscape orientation and on phones
        if ( window.innerWidth > window.innerHeight || window.innerWidth < 400 )
        {
            $([document.documentElement, document.body]).animate({scrollTop: $('.content-wrapper').offset().top}, 1000);
        }
    }
}

function layoutContainer()
{
    var totalWidth = parseInt($('#sailcast-container').width(), 10);
    var timelinePercentage = (totalWidth > 1120 ? 0.40 : (totalWidth > 768 ? 0.30 : 0.20));

    // Override width percentage for phones in landscape
    if ( window.innerHeight <= 450 && window.innerWidth > 500 ) timelinePercentage = 0.30;
    var timelineWidth = (mediaStreamNumPhotos > 0 ? Math.min( 420, (totalWidth * timelinePercentage).toFixed(0) ) : 0);
    var playerWidth = totalWidth - timelineWidth - 6;
    $('#sailcast-player').attr('style', 'width: ' + playerWidth.toFixed(0) + 'px');
    $('#sailcast-photostream').attr('style', 'width: ' + timelineWidth.toFixed(0) + 'px');

    if ( document.getElementById('sailcast-photostream') != null )
    {
        gMediaPhotoTimelineHeight = document.getElementById('sailcast-photostream').scrollHeight;
    }
}

function layoutPlayerView()
{
    var sceneDiv = document.getElementById('scene');
    gRenderer.setSize( sceneDiv.offsetWidth, sceneDiv.offsetHeight );

    gCamera.aspect = sceneDiv.offsetWidth / sceneDiv.offsetHeight;
    gCamera.updateProjectionMatrix();

    if ( gCameraMode === kCameraModeBevGeo || kCameraModeBevWind )
    {
        gCamera.fov = kCameraFovBev;
    }
    else
    {
        gCamera.fov = kCameraFovChase;
    }
    updateCamera();

    $('#scene-canvas').css('opacity', 1.0);
    $('#sailcast-data-spinner').removeClass('fa-spin');
    $('#sailcast-data-spinner').hide();
    $('#loading-data-alert').hide();
    $('#scene-controls').show();
    $('#scene-boat-legend').show();
    $('#scene-camera-toggle').show();
    $('#replay-pause').show();
    $('#replay-scrubber-container').show();

    // Reset the mark cone and annotation positions
    if ( gMarkCones != null && gMarkCones.length > 0
         && gMarkAnnotations != null && gMarkAnnotations.length > 0 )
    {
        for ( i = 0; i < gMarks.length; i++ )
        {
            var pos = translate(gMarks[i].lat, gMarks[i].lon);
            gMarkCones[i].position.x = pos.x;
            gMarkCones[i].position.y = pos.y;

            for ( var j=0; j<gMarkAnnotations.length; j++ )
            {
                if ( gMarkAnnotations[j].index === gMarks[i].index )
                {
                    // The pin has no annotation, so skip it (index 0, no name)
                    if ( (gMarks[i].index === 0 && gMarks[i].name === 'Start') || gMarks[i].index > 0 )
                    {
                        gMarkAnnotations[j].x = pos.x;
                        gMarkAnnotations[j].y = pos.y;
                    }
                }
            }
        }
    }

    setTimeout( function() {
        layoutScrubberTimeline();
    }, 100 );
}

function layoutScrubberTimeline()
{
    var divWidth = $('#replay-scrubber-container').width();

    // Get the effective rendered width of each label after the first paint cycle had a chance to run
    for ( var i = 0; i < gReplayScrubberStops.length; i++ )
    {
        if ( gReplayScrubberStops[i].normalWidth === 0 )
        {
            // Add a 2px margin since sometimes the pixel rounding can cause the width to be 1px too small
            // to fit the text as rendered based on the DIV's x-offset fraction
            gReplayScrubberStops[i].normalWidth = gReplayScrubberStops[i].labelNormed.width() + 2;
        }
    }

    for ( var i=0; i<gReplayScrubberStops.length; i++ )
    {
        var yOffset = $('#replay-scrubber-container').offset().top + 5;
        var lOffset = (gReplayScrubberStops[i].raceTime + gFirstMarkRaceTimeOffset) / gRaceDuration * divWidth;
        lOffset += $('#replay-scrubber-container').offset().left; // Need to account for parent position

        /// Set left offset (adjust for icon width)
        gReplayScrubberStops[i].xOffset = lOffset - 10;
        gReplayScrubberStops[i].label.offset( {left: lOffset - 10, top: yOffset} );
        gReplayScrubberStops[i].labelBr.offset( {left: lOffset - 10, top: yOffset} );
    }

    $('#replay-scrubber').width( divWidth );

    // Adjust visibility of the mark labels based on available space
    var upperLine = true;
    for ( var i=0; i<gReplayScrubberStops.length - 1; i++ )
    {
        var gap = gReplayScrubberStops[i+1].xOffset - gReplayScrubberStops[i].xOffset;
        document.getElementById('rsstop-' + i ).style.width = gReplayScrubberStops[i].normalWidth + 'px';
        document.getElementById('rsstop-' + i ).style.maxWidth = gReplayScrubberStops[i].normalWidth + 'px';

        if ( gReplayScrubberStops[i].label.width() < gap )
        {
            // Text fits - put it above scrubber
            upperLine = true;
            gReplayScrubberStops[i].label.css( 'opacity', 1.0 );
            gReplayScrubberStops[i].labelBr.css( 'opacity', 0.0 );
        }
        else
        {
            if ( upperLine )
            {
                // Text is too long - put it below scrubber
                upperLine = false;
                gReplayScrubberStops[i].label.css( 'opacity', 0.0 );
                gReplayScrubberStops[i].labelBr.css( 'opacity', 1.0 );
            }
            else
            {
                // Text is too long but we already were below scrubber - put it above and truncate the DIV
                upperLine = true;
                gReplayScrubberStops[i].label.css( 'opacity', 1.0 );
                gReplayScrubberStops[i].labelBr.css( 'opacity', 0.0 );
                gReplayScrubberStops[i].label.css( 'maxWidth', Math.max( gap, 16 ) + 'px' );
            }
        }
    }

    // Finish is always in the top row
    gReplayScrubberStops[i].label.css( 'opacity', 1.0 );
    gReplayScrubberStops[i].labelBr.css( 'opacity', 0.0 );
}

function togglePlay()
{
    if ( gReplayActive )
    {
        replayPause();
    }
    else
    {
        replayResume();
    }
}

/* ==============================================================
   LOADING RACE DATA
   ============================================================== */
function loadRaceData()
{
    if ( raceInfos == null || raceInfos.length === 0 )
    {
        return false;
    }

    // Parse the logged marks for each boat entry and sort them as they are not ordered in the JSON.
    for ( var i = 0; i < raceInfos.length; i++ )
    {
        var mlist = JSON.parse(raceInfos[i].markList.replace(/'/g, '"'));
        if ( mlist != null && Array.isArray(mlist) )
        {
             mlist = mlist.sort(function (a, b) {
                return (a.index > b.index ? 1 : -1);
            });

            // Sanity check that the marks have a valid lat/lon/roundingTime
            raceInfos[i].loggedMarkList = [];
            for ( var j=0; j<mlist.length; j++ )
            {
                if ( mlist[j].hasOwnProperty('name') && mlist[j]['name']
                     && mlist[j].hasOwnProperty('lat') && mlist[j]['lat']
                     && mlist[j].hasOwnProperty('lon') && mlist[j]['lon']
                     && mlist[j].hasOwnProperty('roundingRaceTime') && mlist[j]['roundingRaceTime'] )
                {
                    raceInfos[i].loggedMarkList.push( mlist[j] );
                }
                else
                {
                    console.log("Ignoring incomplete mark:");
                    console.log(mlist[j]);
                }
            }
        }
        else
        {
            raceInfos[i].loggedMarkList = [];
        }
    }

    // Find the most complete mark list
    var gReferenceMarkListIndex = 0;
    for ( var i = 1; i < raceInfos.length; i++ )
    {
        if ( raceInfos[i].loggedMarkList.length > raceInfos[gReferenceMarkListIndex].loggedMarkList.length )
        {
            gReferenceMarkListIndex = i;
        }
    }

    /// For now we set the selected boat to the one with the best mark list and draw wind
    /// lines based on this boat:
    gSelectedBoatIndex = gReferenceMarkListIndex;

    // Figure out which boats are in the race logs and create a lookup array for them
    gBoatIdList = new Array();
    for ( var i = 0; i < raceInfos.length; i++ )
    {
        gBoatIdList.push(raceInfos[i].boatId);
    }

    return true;
}

function updateTimelineStopsForSelectedBoatIdx( selectedBoatIdx )
{
    gSelectedBoatIndex = selectedBoatIdx;

    // Save a deep copy as our global mark list as we will add start marks to it
    gMarks = JSON.parse( JSON.stringify( raceInfos[gSelectedBoatIndex].loggedMarkList ) );

    var startBoat = { index: 0,
        lat: raceInfos[gReferenceMarkListIndex].startBoatLat,
        lon: raceInfos[gReferenceMarkListIndex].startBoatLon,
        name: 'Start',
        type: 'start-boat' };

    var startPin = { index: 0,
        lat: raceInfos[gReferenceMarkListIndex].startPinLat,
        lon: raceInfos[gReferenceMarkListIndex].startPinLon,
        name: '',
        type: 'start-pin' };

    // Add the start time, rounding times and names to the time scrubber stops
    var startLabel = $('<div id="rsstop-0" class="replayScrubberStopLabel no-text-select" style="color: rgb(88, 88, 88); opacity: 0.0; max-height: 20px; overflow: hidden; z-index: 100;"><i class="fa fa-map-marker fa-fw" style="color: rgb(255, 178, 0); line-height: 24px;"></i>Start</div>')
        .appendTo($('#replay-scrubber-container'));
    var startLabelNormed = $('<div class="replayScrubberStopLabel no-text-select" style="color: rgb(88, 88, 88); opacity: 0.0; max-height: 20px; overflow: hidden; z-index: 100;"><i class="fa fa-map-marker fa-fw" style="color: rgb(255, 178, 0); line-height: 24px;"></i>Start</div>')
        .appendTo($('#replay-scrubber-container'));
    var startLabelBr = $('<div class="replayScrubberStopLabel no-text-select" style="color: rgb(88, 88, 88); opacity: 0.0; overflow: hidden; z-index: 100;"><i class="fa fa-map-marker fa-fw" style="color: rgb(255, 178, 0); line-height: 24px;"></i><br>Start</div>')
        .appendTo($('#replay-scrubber-container'));
    startLabel.css('left', '0px');
    startLabelBr.css('left', '0px');

    var start = {
        label: startLabel,
        labelNormed: startLabelNormed,
        labelBr: startLabelBr,
        brActive: false,
        xOffset: 0,
        normalWidth: 0,
        raceTime: 0,
        utcTime: raceInfos[0].startTimeUtc,
        name: 'Start' };
    gReplayScrubberStops.push( start );

    for ( var i=0; i<gMarks.length; i++ )
    {
        if ( gMarks[i].name === 'START-FINISH' )
        {
            gMarks[i].name = 'Finish';
        }

        var stopLabel = $('<div id="rsstop-' + (i+1) + '" class="replayScrubberStopLabel no-text-select" style="color: rgb(88, 88, 88); opacity: 0.0; max-height: 20px; overflow: hidden; z-index: 100;"><i class="fa fa-map-marker fa-fw" style="color: rgb(255, 178, 0); line-height: 24px;"></i>' + gMarks[i].name + '</div>')
            .appendTo($('#replay-scrubber-container'));
        var stopLabelNormed = $('<div class="replayScrubberStopLabel no-text-select" style="color: rgb(88, 88, 88); opacity: 0.0; max-height: 20px; overflow: hidden; z-index: 100;"><i class="fa fa-map-marker fa-fw" style="color: rgb(255, 178, 0); line-height: 24px;"></i>' + gMarks[i].name + '</div>')
            .appendTo($('#replay-scrubber-container'));
        var stopLabelBr = $('<div class="replayScrubberStopLabel no-text-select" style="color: rgb(88, 88, 88); opacity: 0.0; overflow: hidden; z-index: 100;"><i class="fa fa-map-marker fa-fw" style="color: rgb(255, 178, 0); line-height: 24px;"></i><br>' + gMarks[i].name + '</div>')
            .appendTo($('#replay-scrubber-container'));
        stopLabel.css('left', '0px');
        stopLabelBr.css('left', '0px');

        var stop = {
            label: stopLabel,
            labelNormed: stopLabelNormed,
            labelBr: stopLabelBr,
            brActive: false,
            xOffset: 0,
            normalWidth: 0,
            raceTime: gMarks[i].roundingRaceTime,
            utcTime: gMarks[i].roundingUtcTime,
            name: gMarks[i].name };
        gReplayScrubberStops.push( stop );

        var annotationDiv = document.createElement('div');
        annotationDiv.id = 'mark-annotation-' + gMarks[i].index;
        annotationDiv.style.position = 'absolute';
        annotationDiv.style.width = 100;
        annotationDiv.style.height = 50;
        annotationDiv.style.top = 0 + 'px';
        annotationDiv.style.left = 9999 + 'px';
        annotationDiv.style.zIndex = 5000;
        if ( gMarks[i].name === 'FINISH' || gMarks[i].name === 'Finish' )
        {
            if ( !((gMarks[i].lat > startBoat.lat - 0.0001 && gMarks[i].lat < startBoat.lat + 0.0001)
                   &&
                   (gMarks[i].lon > startBoat.lon - 0.0001 && gMarks[i].lon < startBoat.lon + 0.0001)) )
            {
                annotationDiv.innerHTML = '<p class="mark-legend no-text-select">' + gMarks[i].name + '</p>';
            }
        }
        else
        {
            annotationDiv.innerHTML = '<p class="mark-legend">' + gMarks[i].name + '</p>';
        }
        document.getElementById('scene').appendChild( annotationDiv );
    }

    // Add headings to marks for up-/downwind determination
    if ( gMarks.length > 0 )
    {
        gMarks[0].xhdt = mvutils_calculate_xhdm(startBoat, gMarks[0]);
        console.log( 'Heading 0: ' + gMarks[0].xhdt);
    }
    for ( var m=1; m<gMarks.length; m++ )
    {
        gMarks[m].xhdt = mvutils_calculate_xhdm( gMarks[m-1], gMarks[m] );
        console.log( 'Heading ' + m + ': ' + gMarks[m].xhdt);
    }

    gMarks.unshift( startPin );
    gMarks.unshift( startBoat );

    var startDiv = document.createElement('div');
    startDiv.id = 'mark-annotation-0';
    startDiv.style.position = 'absolute';
    startDiv.style.width = 100;
    startDiv.style.height = 50;
    startDiv.style.top = 0 + 'px';
    startDiv.style.left = 9999 + 'px';
    startDiv.style.color = '#fff200';
    startDiv.innerHTML = '<p class="mark-legend">START</p>';
    document.getElementById('scene').appendChild( startDiv );
}

function replaySpeedChanged( speed )
{
    gPlaybackSpeed = speed;
    mvutils_avg360_reset( gTwdDisplayAvg, gTwdDampTime * Math.round(gPlaybackSpeed) );
    mvutils_avg360_reset( gTwdCameraAvg, gTwdCameraDampTime * Math.round(gPlaybackSpeed) );
    mvutils_avg360_reset( gTwaTgtUpAvg, gTwdDampTime * Math.round(gPlaybackSpeed) );
    mvutils_avg360_reset( gTwaTgtDownAvg, gTwdDampTime * Math.round(gPlaybackSpeed) );

    for ( var i=0; i<numBoats; i++ )
    {
        mvutils_avg360_reset( gHdmAvgPerBoat[i], gHdmDampTime * Math.round(gPlaybackSpeed) );
    }
}

/* ==============================================================
   CAMERA CONTROL
   ============================================================== */
function toggleCameraMode()
{
    // Update the camera mode
    if ( gCameraMode === kCameraModeBevGeo )
    {
        gCameraMode = kCameraModeBevWind;
        gCamera.fov = kCameraFovBev;

        windIndicatorShow();

        gEgoScale = kEgoScaleBev;
        gBoatAnnotationOffset = 0.1;
        gMarkScale = kMarkScaleBev;
        gMarkAnnotationOffset = 0.5;
        $('.boat-annotation-group').height( 72 );
        $('#scene-camera-toggle').css( 'background-image', 'url("' + gAssetPrefix + '/img/ic-cam-wind.png"');
    }
    else if ( gCameraMode === kCameraModeBevWind )
    {
        gCameraMode = kCameraModeChase;
        gCamera.fov = kCameraFovChase;

        windIndicatorHide();

        gEgoScale = 1.0;
        gBoatAnnotationOffset = -0.14;
        gMarkScale = 0.5;
        gMarkAnnotationOffset = -0.18;
        $('.boat-annotation-group').height( 120 );
        $('#scene-camera-toggle').css( 'background-image', 'url("' + gAssetPrefix + '/img/ic-cam-chase.png"');
    }
    else
    {
        gCameraMode = kCameraModeBevGeo;
        gCamera.fov = kCameraFovBev;
        gCamera.position.set( 0, -kCameraPlaneGeoDistance, kCameraPlaneHeightDistance );
        gCamera.up = new THREE.Vector3(0,0,1);
        gCamera.lookAt( new THREE.Vector3(gScene.position.x, gScene.position.y, gScene.position.z + kCameraLookAtOffset) );

        windIndicatorShow();

        gEgoScale = kEgoScaleBev;
        gBoatAnnotationOffset = 0.1;
        gMarkScale = kMarkScaleBev;
        gMarkAnnotationOffset = 0.5;
        $('.boat-annotation-group').height( 72 );
        $('#scene-camera-toggle').css( 'background-image', 'url("' + gAssetPrefix + '/img/ic-cam-north.png"');
    }

    // Update scale of boat
    for ( var i=0; i<numBoats; i++ )
    {
        gBoats[i].scale.set( gEgoScale, gEgoScale, gEgoScale );

        for ( var d=0; d<gBoatTrailSize; d++ )
        {
            gBoatTrails[i][d].scale.set( gEgoScale, gEgoScale, gEgoScale );
        }
    }

    // Update scale of mark cones
    for ( var i=0; i<gMarkCones.length; i++ )
    {
        gMarkCones[i].scale.set( gMarkScale, gMarkScale, gMarkScale );
    }

    updateCamera();
}

function updateCamera()
{
    // Adjust the camera according to mode
    if ( gCameraMode === kCameraModeBevWind )
    {
        var x = Math.sin( mvutils_add360( gTwdCameraAvg.avg, 180 ) * kDegToRad ) * kCameraPlaneGeoDistance;
        var y = Math.cos( mvutils_add360( gTwdCameraAvg.avg, 180 ) * kDegToRad ) * kCameraPlaneGeoDistance;

        gCamera.position.set(x, y, kCameraPlaneHeightDistance); /// 18
        gCamera.up = new THREE.Vector3(0,0,1);
        gCamera.lookAt(new THREE.Vector3(gScene.position.x, gScene.position.y, gScene.position.z + kCameraLookAtOffset));
    }
    else if ( gCameraMode === kCameraModeChase )
    {
        var pos = getPastPositionForBoat( 20, gSelectedBoatIndex );

        // Extend camera position further back
        var cx = gSelectedBoatPos.x + gBoatChaseDistance * (pos.x - gSelectedBoatPos.x);
        var cy = gSelectedBoatPos.y + gBoatChaseDistance * (pos.y - gSelectedBoatPos.y);

        //console.log('CAM-POS, ' + cy + ',' + gSelectedBoatPos.y + ', ' + pos.y);

        gCamera.position.set(cx, cy, gWaterLevel + 0.3);
        gCamera.up = new THREE.Vector3(0,0,1);
        gCamera.lookAt(new THREE.Vector3(gSelectedBoatPos.x, gSelectedBoatPos.y, gWaterLevel + 0.1));
    }
}

/* ==============================================================
   RENDERING FUNCTIONS
   ============================================================== */
function animate()
{
    if ( gReplayActive )
    {
        requestAnimationFrame( animate );
    }

    // Use absolute time delta to determine step sizes
    var delta = renderClock.getDelta();
    if ( delta > 0.5 )
    {
        // We got paused (by button or switching to another tab),
        // so just continue with the next normal rendering interval
        return;
    }

    gRenderMeasuredInterval += delta;
    gPhotoTimelineAnimationInterval += delta;
    if ( gRenderMeasuredInterval > gRenderInterval )
    {
        gPlaybackTime += (gRenderMeasuredInterval * gPlaybackSpeed);
        if (gPlaybackTime >= gRaceDuration - 1.0) {
            gPlaybackTime = 0.0;
            gPlaybackIndex = 0;
        }

        gRenderMeasuredInterval = 0;

        var playbackData = getRecordsAtCurrentPlaybackTime();

        if ( playbackData.recList != null )
        {
            renderBoats( playbackData.recList );

            renderMarkAnnotations();

            renderWindLines( playbackData.nextMarkIdx );

            updateCamera();

            gReplayScrubber.value = gPlaybackTime * (1000.0 / gRaceDuration);

            gRenderer.render( gScene, gCamera );
        }
    }

    if ( /*gPhotoTimelineAnimationInterval > 1.0 &&*/ document.getElementById('sailcast-photostream') != null )
    {
        var photoTimelineTop = 0;
        if ( gPlaybackTime > 0 && gRaceDuration > 10 )
        {
            photoTimelineTop = gPlaybackIndex / gRaceDuration * document.getElementById('sailcast-photostream').scrollHeight.toFixed(1);
        }
        document.getElementById('sailcast-photostream').scrollTop = photoTimelineTop;
        //$('#sailcast-photostream').animate({
        //    scrollTop: photoTimelineTop
        //}, gPhotoTimelineAnimationInterval * 1000.0);
        //gPhotoTimelineAnimationInterval = 0;
    }
}

function replayResume()
{
    gReplayActive = true;
    $('#replay-pause').html('Pause');

    animate();
}

function replayPause()
{
    gReplayActive = false;
    $('#replay-pause').html('Play');
}

function replaySkipTo( racetime )
{
    //console.log( 'Skipping from ' + gPlaybackTime + ' to ' + racetime);
    var index = gPlaybackIndex;

    if ( racetime > gPlaybackTime )
    {
        // Skipping forward
        while ( racetime > (gRecords[index][0].rtime / 100.0 - gRaceStartTime) )
        {
            index++;
            if ( index >= gNumRecords - 2 )
            {
                index = gNumRecords - 2;
                break;
            }
        }
    }
    else
    {
        // Skipping back in time
        while ( racetime < (gRecords[index][0].rtime / 100.0 - gRaceStartTime) )
        {
            index--;
            if ( index < 0 )
            {
                index = 0;
                break;
            }
        }
    }

    gPlaybackTime = gRecords[index][0].rtime / 100.0 - gRaceStartTime;
    gPlaybackIndex = index;
}

function updateLeaderBoard( rec )
{
    // Sanity check for more than one boat
    if ( rec.length < 2 ) return;

    // Only run this twice a second if we have at least two boats
    if ( gLeaderCalculationHold ) return;
    gLeaderCalculationHold = true;
    setTimeout( function() { gLeaderCalculationHold = false; }, 500 );

    // Sanity check that the race started for all boats (in a pursuit start we only show this once all boats started)
    var raceStarted = true;
    for ( var i=0; i<rec.length; i++ )
    {
        if ( rec[i].racetime < 5 )
        {
            raceStarted = false;
            gLeaderBoard = null;
            return;
        }
    }

    // First, find the leading leg index of all boats
    var leadingLegIdx = 0;
    for ( i=0; i<rec.length; i++ )
    {
        leadingLegIdx = Math.max( leadingLegIdx, rec[i].legIdx );
    }
    if ( leadingLegIdx >= gMarks.length )
    {
        console.log('Found more leg indices than marks!');
        return null;
    }

    // Next we look for at least 2 of the top three boats to be on the same leading leg
    var twoBoatRace = (rec.length === 2);
    var legWithLeadingBoat = -1;
    var legWithDistanceLines = -1;
    var leadCandidate = -1;
    for ( var li=leadingLegIdx; li >= 0; li-- )
    {
        var occupancy = 0;
        for ( i=0; i<rec.length; i++ )
        {
            // Loop through all boats to see who is on this leg. leadCandidate is only used if the first
            // boat is by itself on the leading leg - so only save the first boat we encounter on the leading leg.
            if ( rec[i].legIdx === li )
            {
                if ( leadCandidate === -1 ) leadCandidate = i;
                occupancy++;
            }
        }
        if ( occupancy === 1 && li === leadingLegIdx )
        {
            // The leading leg has a single boat on it
            legWithLeadingBoat = li;
        }
        if ( occupancy >= 2
             ||
             (twoBoatRace && li<legWithLeadingBoat && occupancy === 1) )
        {
            // The leg has at least 2 boats on it or we only have two boats
            legWithDistanceLines = li;
            break;
        }
    }
    if ( legWithLeadingBoat === -1 && legWithDistanceLines === -1 )
    {
        gLeaderBoard = null;
        return;
    }

    gLeaderBoard = null;
    gLeaderBoard = new Array();

    // If the leading boat is past the last mark stop calculating
    if ( leadingLegIdx >= gLegs.length ) return;

    // Check if we have a single leader already one leg ahead and adjust for the distance they already sailed from the mark
    var leaderDistancePastMark = 0;
    if ( legWithLeadingBoat > legWithDistanceLines && leadCandidate >= 0 && legWithLeadingBoat > 0 )
    {
        var vmgDistFromPrevMark;
        var distFromPrevMark = mvutils_distanceFromTo( gLegs[legWithLeadingBoat-1].lat,
                                                       gLegs[legWithLeadingBoat-1].lon,
                                                       rec[leadCandidate].lat,
                                                       rec[leadCandidate].lon ) * 1852.0;
        var headingFromPrevMark = mvutils_calculate_xhdm( {lat: gLegs[legWithLeadingBoat-1].lat, lon: gLegs[legWithLeadingBoat-1].lon},
                                                          {lat: rec[leadCandidate].lat, lon: rec[leadCandidate].lon} );
        headingFromPrevMark = mvutils_add360( headingFromPrevMark, -rec[leadCandidate].magvar );

        if ( legIsReaching( legWithLeadingBoat ) )
        {
            vmgDistFromPrevMark = Math.abs( distFromPrevMark * Math.cos( mvutils_substract360(gLegs[leadingLegIdx].legHdm, headingFromPrevMark) * kDegToRad ) );
        }
        else
        {
            vmgDistFromPrevMark = Math.abs(distFromPrevMark * Math.cos(mvutils_substract360(gTwd, headingFromPrevMark) * kDegToRad));
        }
        //console.log('Lead dist from last mark: ' + distFromPrevMark.toFixed(0) + ' | @ ' + mvutils_substract360(gTwd, headingFromPrevMark).toFixed(1) + 'º | ' + vmgDistFromPrevMark.toFixed(0));

        /// Need to check for VMG vs straight reaching
        leaderDistancePastMark = vmgDistFromPrevMark;

        gLeaderBoard.push( { idx: leadCandidate, dist: 0, gap: 0 } );
    }

    // Now find the leading two or three boats within the leading leg
    var legCandidates = new Array();
    for ( var i=0; i<rec.length; i++ )
    {
        if ( rec[i].xDist > 0 && rec[i].xDist !== 999999 && rec[i].legIdx === legWithDistanceLines )
        {
            var vmgDist;
            if ( legIsReaching( legWithDistanceLines ) )
            {
                vmgDist = Math.abs(rec[i].xDist * Math.cos(mvutils_substract360(gLegs[legWithDistanceLines].legHdm, rec[i].xHdm) * kDegToRad));
            }
            else
            {
                vmgDist = Math.abs(rec[i].xDist * Math.cos(mvutils_substract360(gTwd, rec[i].xHdm) * kDegToRad));
            }
            //console.log('Dist [' + i + '] to mark: ' + vmgDist.toFixed(0));
            legCandidates.push( { idx: i, dist: vmgDist } );
        }
    }
    legCandidates.sort(function(a, b) {
        if (a.dist > b.dist) {
            return 1;
        }
        if (a.dist < b.dist) {
            return -1;
        }
        return 0;
    });

    for ( i=0; i<Math.min(3, legCandidates.length); i++ )
    {
        gLeaderBoard.push( { idx: legCandidates[i].idx, dist: leaderDistancePastMark + legCandidates[i].dist, gap: 0.0 } );
    }
    for ( i=1; i<gLeaderBoard.length; i++ )
    {
        gLeaderBoard[i].gap = gLeaderBoard[i].dist - gLeaderBoard[i-1].dist;
    }
}

function legIsReaching( idx )
{
    if ( idx >= gLegs.length ) return true;

    // Check if we have an up/downwind or a reaching leg
    var legTwa = Math.abs( mvutils_substract360( gTwd, gLegs[idx].legHdm ) );
    return (legTwa > gTwaTgtUp && legTwa < gTwaTgtDown);
}

function colorForBoatIndex( idx )
{
    var color = kTrailColors[idx % kTrailColors.length].toString(16);

    // Add leading zeros
    while ( color.length < 6 ) color = '0' + color;

    return '#' + color;
}

function renderBoats( rec )
{
    if ( gBoats.length > 1 )
    {
        updateLeaderBoard(rec);
        if ( gLeaderBoard !== null && gLeaderBoard.length >= 2 )
        {
            $('#leader-1-name').html( raceInfos[gLeaderBoard[0].idx].sailcastName );
            $('#leader-1-dist').html( gLeaderBoard[0].gap.toFixed(0) + 'm' );
            $('#leader-1-vmg').html( rec[gLeaderBoard[0].idx].vmg.toFixed(1) + 'kn' );
            $('#leader-1-name').css( 'color', colorForBoatIndex(gLeaderBoard[0].idx) );
            $('#leader-1-dist').css( 'color', colorForBoatIndex(gLeaderBoard[0].idx) );
            $('#leader-1-vmg').css( 'color', colorForBoatIndex(gLeaderBoard[0].idx) );

            $('#leader-2-name').html( raceInfos[gLeaderBoard[1].idx].sailcastName );
            $('#leader-2-dist').html( gLeaderBoard[1].gap.toFixed(0) + 'm' );
            $('#leader-2-vmg').html( rec[gLeaderBoard[1].idx].vmg.toFixed(1) + 'kn' );
            $('#leader-2-name').css( 'color', colorForBoatIndex(gLeaderBoard[1].idx) );
            $('#leader-2-dist').css( 'color', colorForBoatIndex(gLeaderBoard[1].idx) );
            $('#leader-2-vmg').css( 'color', colorForBoatIndex(gLeaderBoard[1].idx) );

            if ( gLeaderBoard.length > 2 )
            {
                $('#leader-3-name').html( raceInfos[gLeaderBoard[2].idx].sailcastName );
                $('#leader-3-dist').html( gLeaderBoard[2].gap.toFixed(0) + 'm' );
                $('#leader-3-vmg').html( rec[gLeaderBoard[2].idx].vmg.toFixed(1) + 'kn' );
                $('#leader-3-name').css( 'color', colorForBoatIndex(gLeaderBoard[2].idx) );
                $('#leader-3-dist').css( 'color', colorForBoatIndex(gLeaderBoard[2].idx) );
                $('#leader-3-vmg').css( 'color', colorForBoatIndex(gLeaderBoard[2].idx) );
            }

            $('#scene-leader-board').show();
        }
        else
        {
            $('#scene-leader-board').hide();
        }
    }

    for ( i=0; i<gBoats.length; i++ )
    {
        if ( rec[i].lat !== 0 && rec[i].lon !== 0 )
        {
            // Get wind speed
            var tws = parseFloat(rec[i].tws).toFixed(1);

            // Get position in scene coordinates
            var pos = translate( rec[i].lat, rec[i].lon );
            if ( i === gSelectedBoatIndex )
            {
                gSelectedBoatPos = pos;
                gTws = tws;
            }

            // Adjust boat position and orientation
            gBoats[i].position.x = pos.x;
            gBoats[i].position.y = pos.y;
            gBoats[i].position.z = gWaterLevel;
            gBoats[i].rotation.z = -(rec[i].hdm + rec[i].magvar - 90.0) * kDegToRad;

            // Check if we jumped in time and reset the trail
            if ( Math.abs( gBoatTrailIndex[i].time - gPlaybackTime ) > 30 )
            {
                // Sink all dots in the ocean
                for ( var d=0; d<gBoatTrailSize; d++ )
                {
                    gBoatTrails[i][d].position.z = -9999;
                }

                // Reset dot trail meta data
                gBoatTrailIndex[i].time = gPlaybackTime;
                gBoatTrailIndex[i].index = gBoatTrailSize-1;

                // Redraw dots for current time
                for ( var d=0; d<gBoatTrailSize-2 && gPlaybackTime > d * gBoatTrailInterval; d++ )
                {
                    var dTime = gBoatTrailInterval * d;
                    var dotPos = getPastPositionForBoat( dTime, i );
                    var dot = gBoatTrails[i][gBoatTrailIndex[i].index-d];
                    dot.position.x = dotPos.x;
                    dot.position.y = dotPos.y;
                    dot.position.z = gWaterLevel + 0.001;
                }

                // Adjust trail to fade at the end
                for ( var d=0; d<gBoatTrailSize; d++ )
                {
                    var op = Math.min( 1.0, d / (gBoatTrailSize / 2) );
                    gBoatTrails[i][(gBoatTrailIndex[i].index + d) % gBoatTrailSize].material.opacity = op;
                }
            }

            // Update boat trail
            if ( gPlaybackTime > (gBoatTrailIndex[i].time + gBoatTrailInterval) )
            {
                //console.log('Adding DOT at ' + gPlaybackTime);
                gBoatTrailIndex[i].index++;
                gBoatTrailIndex[i].index %= gBoatTrailSize;
                gBoatTrailIndex[i].time = gPlaybackTime;

                var dot = gBoatTrails[i][gBoatTrailIndex[i].index];
                dot.position.x = pos.x;
                dot.position.y = pos.y;
                dot.position.z = gWaterLevel + 0.001;

                // Adjust trail to fade at the end
                for ( var d=0; d<gBoatTrailSize; d++ )
                {
                    var op = Math.min( 1.0, d / (gBoatTrailSize / 2) );
                    gBoatTrails[i][(gBoatTrailIndex[i].index + d) % gBoatTrailSize].material.opacity = op;
                }
            }

            // Update boat annotation
            var bname = (raceInfos[i].sailcastName == null
                         ? raceInfos[i].boatName.replace(/\s/g,'').toUpperCase().substring(0,3) : raceInfos[i].sailcastName);
            var stw = parseFloat(rec[i].stw).toFixed( 2 );
            var windDir = parseFloat(rec[i].twa).toFixed(0);
            var viewportPos = getViewportCoordinates( {x: gBoats[i].position.x, y: gBoats[i].position.y, z: gBoats[i].position.z+gBoatAnnotationOffset} );
            var annotationHtml = document.getElementById( 'boat-annotation-' + i );
            var callSignColor = colorForBoatIndex(i);
            annotationHtml.innerHTML = '<p class="callsign-legend" style="color: ' + callSignColor + '">' + bname + '</p><p class="boat-legend">' + (stw === '999999.00' ? '---' : stw + 'kn') + '</p><p class="wind-legend">' + (windDir === '999999' ? '---' : windDir + 'º') + '</p><p class="wind-legend">' + (tws === '999999.0' ? '---' : tws + 'kn') + '</p>';
            annotationHtml.style.bottom = $('#scene').height() - viewportPos.y + 'px';
            annotationHtml.style.left = viewportPos.x + 'px';

            // Update start timer
            if ( i === 0 )
            {
                if ( gRaceTimer !== rec[i].raceTime )
                {
                    var timerDiv = document.getElementById('scene-start-timer');
                    var timer = document.getElementById('start-timer');

                    if ( rec[i].racetime <= 0 )
                    {
                        var min = Math.floor(Math.abs(rec[i].racetime / 60));
                        var sec = Math.abs(rec[i].racetime % 60);
                        timer.innerHTML = min.toFixed(0).toString().padStart(2, '0') + ':' + sec.toString().padStart(2, '0');
                        timer.style.width = '60px';
                        timerDiv.style.left = $('#scene').width() / 2 - 30 + 'px';
                    }
                    else if ( gLegs.length > 1 )
                    {
                        var leadBoatIdx = (gLeaderBoard !== null && gLeaderBoard.length > 0 ? gLeaderBoard[0].idx : 0);
                        timer.innerHTML = 'LEG ' + (rec[leadBoatIdx].legIdx + 1) + '/' + gLegs.length;
                        if ( gLegs.length < 10 )
                        {
                            timer.style.width = '80px';
                            timerDiv.style.left = $('#scene').width() / 2 - 40 + 'px';
                        }
                        else
                        {
                            timer.style.width = '100px';
                            timerDiv.style.left = $('#scene').width() / 2 - 50 + 'px';
                        }
                    }
                    else
                    {
                        timerDiv.style.left = '9999px';
                    }
                    gRaceTimer = rec[i].racetime;
                }
            }
        }
    }

    if ( water !== null )
    {
        var xFlow = -Math.sin(gTwd * kDegToRad);
        var yFlow = Math.cos(gTwd * kDegToRad);
        var flowDirection = new THREE.Vector2(xFlow, yFlow);
        water.material.uniforms["flowDirection"] = {
            type: 'v2',
            value: flowDirection
        };
    }
}

function renderMarkAnnotations()
{
    if ( gMarkAnnotations == null ) return;

    // Mark names
    for ( var i=0; i<gMarkAnnotations.length; i++ )
    {
        var annotation = document.getElementById('mark-annotation-' + i);
        if ( annotation !== null )
        {
            var viewportPos = getViewportCoordinates({x: gMarkAnnotations[i].x, y: gMarkAnnotations[i].y, z: gMarkAnnotations[i].z + gMarkAnnotationOffset});
            annotation.style.top = viewportPos.y + 'px';
            annotation.style.left = viewportPos.x + 'px';
        }
    }

    // Starting line (only during pre-start)
    if ( gRaceTimer < 0 )
    {
        if ( gStartingLine == null )
        {
            // First render
            var geometry = new THREE.Geometry();
            var boat = translate( raceInfos[0].startBoatLat, raceInfos[0].startBoatLon );
            var pin = translate( raceInfos[0].startPinLat, raceInfos[0].startPinLon );
            geometry.vertices.push(new THREE.Vector3( boat.x, boat.y, gCourseLevel) );
            geometry.vertices.push(new THREE.Vector3( pin.x, pin.y, gCourseLevel) );
            gStartingLine = new THREE.Line( geometry, gStartingLineMaterialPre );
            gStartingLine.name = 'START';

            gScene.add( gStartingLine );
        }
        else
        {
            gStartingLine.material = gStartingLineMaterialPre;
        }
    }
    else if ( gRaceTimer <= 10 )
    {
        if ( gStartingLine == null )
        {
            // First render
            var geometry = new THREE.Geometry();
            var boat = translate( raceInfos[0].startBoatLat, raceInfos[0].startBoatLon );
            var pin = translate( raceInfos[0].startPinLat, raceInfos[0].startPinLon );
            geometry.vertices.push(new THREE.Vector3( boat.x, boat.y, gCourseLevel) );
            geometry.vertices.push(new THREE.Vector3( pin.x, pin.y, gCourseLevel) );
            gStartingLine = new THREE.Line( geometry, gStartingLineMaterialPost );
            gStartingLine.name = 'START';

            gScene.add( gStartingLine );
        }
        else
        {
            gStartingLine.material = gStartingLineMaterialPost;
        }
    }
    else
    {
        gScene.remove( gStartingLine );
        gStartingLine = null;
    }
}

function renderWindLines( nextMarkIdx )
{
    // Step 1: Get the next mark's position
    var lat = 0, lon = 0, pLat = 0, pLon = 0, nextIdx = -1, prevIdx = (nextMarkIdx > 0 ? nextMarkIdx - 1 : -1);

    if ( nextMarkIdx >= raceInfos[gSelectedBoatIndex].loggedMarkList.length )
    {
        // Remove any existing laylines and ladder lines
        if ( gLaylines !== null )
        {
            gScene.remove( gLaylines );
            gLaylines = null;
        }
        if ( gLadderLines !== null && gLadderLines.length > 0 )
        {
            for ( var ll=0; ll<gLadderLines.length; ll++ )
            {
                gScene.remove( gLadderLines[ll] );
            }
            gLadderLines = null;
        }

        return;
    }

    lat = raceInfos[gSelectedBoatIndex].loggedMarkList[nextMarkIdx].lat;
    lon = raceInfos[gSelectedBoatIndex].loggedMarkList[nextMarkIdx].lon;
    gNextMarkHDT = raceInfos[gSelectedBoatIndex].loggedMarkList[nextMarkIdx].xhdt;

    if ( prevIdx === -1 )
    {
        // Use the start position for the beginning of the first leg
        pLat = gMarks[0].lat;
        pLon = gMarks[0].lon;
    }
    else
    {
        pLat = raceInfos[gSelectedBoatIndex].loggedMarkList[prevIdx].lat;
        pLon = raceInfos[gSelectedBoatIndex].loggedMarkList[prevIdx].lon;
    }

    if ( lat === 0 || lon === 0 || pLat === 0 || pLon === 0 )
    {
        return;
    }

    var mpos = translate( lat, lon );
    var prevMpos = translate( pLat, pLon );

    // Remove the trackline if we changed marks
    if ( gTrackLineMark !== gXName )
    {
        if ( gTrackline !== null )
        {
            gScene.remove( gTrackline );
            gTrackline = null;
        }

        gTrackLineMark = gXName;
    }

    if ( gTwaTgtPointOfSail === kNextMarkIsReaching )
    {
        // Remove any existing laylines and ladder lines
        if ( gLaylines !== null )
        {
            gScene.remove( gLaylines );
            gLaylines = null;
        }
        if ( gLadderLines !== null && gLadderLines.length > 0 )
        {
            for ( var ll=0; ll<gLadderLines.length; ll++ )
            {
                gScene.remove( gLadderLines[ll] );
            }
            gLadderLines = new Array();
        }

        if ( prevMpos !== null && gTrackline === null )
        {
            var tgeometry = new THREE.Geometry();
            tgeometry.vertices.push(new THREE.Vector3(prevMpos.x, prevMpos.y, gCourseLevel));
            tgeometry.vertices.push(new THREE.Vector3(mpos.x, mpos.y, gCourseLevel));
            gTrackline = new THREE.Line(tgeometry, gTracklineMaterial);
            gTrackline.name = 'TRACK LINE';
            gTrackline.computeLineDistances();

            gScene.add( gTrackline );
        }

        return;
    }
    else
    {
        // Remove any reaching leg graph
        if ( gTrackline !== null )
        {
            gScene.remove( gTrackline );
            gTrackline = null;
        }
    }

    // Step 2: Render ladder lines
    var sbx, sby, ptx, pty;
    var upAvg = (gTwaTgtUpAvg.avg === 999999 ? gTwaTgtUp : gTwaTgtUpAvg.avg);
    var downAvg = (gTwaTgtDownAvg.avg === 999999 ? gTwaTgtDown : gTwaTgtDownAvg.avg);
    for ( var j=0; j<10; j++ )
    {
        if ( gTwaTgtPointOfSail === kNextMarkIsUpwind)
        {
            sbx = mpos.x + Math.sin(mvutils_add360(gTwd, 180 - upAvg) * kDegToRad) * j;
            sby = mpos.y + Math.cos(mvutils_add360(gTwd, 180 - upAvg) * kDegToRad) * j;
            ptx = mpos.x + Math.sin(mvutils_substract360(gTwd, 180 - upAvg) * kDegToRad) * j;
            pty = mpos.y + Math.cos(mvutils_substract360(gTwd, 180 - upAvg) * kDegToRad) * j;
        }
        else if ( gTwaTgtPointOfSail === kNextMarkIsDownwind )
        {
            // Use a downwind TWA of 145 so the ladder lines don't collapse too far
            sbx = mpos.x + Math.sin(mvutils_substract360(gTwd, 180 - 145) * kDegToRad) * j;
            sby = mpos.y + Math.cos(mvutils_substract360(gTwd, 180 - 145) * kDegToRad) * j;
            ptx = mpos.x + Math.sin(mvutils_add360(gTwd, 180 - 145) * kDegToRad) * j;
            pty = mpos.y + Math.cos(mvutils_add360(gTwd, 180 - 145) * kDegToRad) * j;
        }

        if ( gLadderLines === null ) gLadderLines = [];

        if ( gLadderLines.length < 10 )
        {
            // First render
            var geometry = new THREE.Geometry();
            geometry.vertices.push(new THREE.Vector3( sbx, sby, gLaylineLevel) );
            geometry.vertices.push(new THREE.Vector3( ptx, pty, gLaylineLevel) );
            gLadderLines.push( new THREE.Line( geometry, gLadderLinesMaterial ) );
            gLadderLines.name = 'LADDER LINES';

            gScene.add( gLadderLines[j] );
        }
        else
        {
            // Just update the existing lines
            gLadderLines[j].geometry.vertices[ 0 ].x = sbx;
            gLadderLines[j].geometry.vertices[ 0 ].y = sby;
            gLadderLines[j].geometry.vertices[ 1 ].x = ptx;
            gLadderLines[j].geometry.vertices[ 1 ].y = pty;
            gLadderLines[j].geometry.verticesNeedUpdate = true;
        }
    }

    // Step 3: Calculate vertices for laylines
    if ( gTwaTgtPointOfSail === kNextMarkIsUpwind)
    {
        sbx = mpos.x + Math.sin(mvutils_add360(gTwd, 180 - upAvg) * kDegToRad) * gLaylineLength;
        sby = mpos.y + Math.cos(mvutils_add360(gTwd, 180 - upAvg) * kDegToRad) * gLaylineLength;
        ptx = mpos.x + Math.sin(mvutils_substract360(gTwd, 180 - upAvg) * kDegToRad) * gLaylineLength;
        pty = mpos.y + Math.cos(mvutils_substract360(gTwd, 180 - upAvg) * kDegToRad) * gLaylineLength;
    }
    else if ( gTwaTgtPointOfSail === kNextMarkIsDownwind )
    {
        sbx = mpos.x + Math.sin(mvutils_substract360(gTwd, 180 - downAvg) * kDegToRad) * gLaylineLength;
        sby = mpos.y + Math.cos(mvutils_substract360(gTwd, 180 - downAvg) * kDegToRad) * gLaylineLength;
        ptx = mpos.x + Math.sin(mvutils_add360(gTwd, 180 - downAvg) * kDegToRad) * gLaylineLength;
        pty = mpos.y + Math.cos(mvutils_add360(gTwd, 180 - downAvg) * kDegToRad) * gLaylineLength;
    }

    // Step 4: Draw laylines
    if ( gLaylines == null )
    {
        var lgeometry = new THREE.Geometry();
        lgeometry.vertices.push(new THREE.Vector3(sbx, sby, gLaylineLevel));
        lgeometry.vertices.push(new THREE.Vector3(mpos.x, mpos.y, gLaylineLevel));
        lgeometry.vertices.push(new THREE.Vector3(ptx, pty, gLaylineLevel));
        gLaylines = new THREE.Line(lgeometry, gLaylineMaterial);
        gLaylines.name = 'LAYLINES';

        gScene.add(gLaylines);
    }
    else
    {
        gLaylines.geometry.vertices[ 0 ].x = sbx;
        gLaylines.geometry.vertices[ 0 ].y = sby;
        gLaylines.geometry.vertices[ 1 ].x = mpos.x;
        gLaylines.geometry.vertices[ 1 ].y = mpos.y;
        gLaylines.geometry.vertices[ 2 ].x = ptx;
        gLaylines.geometry.vertices[ 2 ].y = pty;
        gLaylines.geometry.verticesNeedUpdate = true;
    }
}

/* ==============================================================
   RECORD ACCESS
   ============================================================== */
var logCnt = 0;

function getRecordsAtCurrentPlaybackTime()
{
    var rec = new Array();
    var markIdx = 0;

    // Check if the playback index needs advancing
    if ( gPlaybackIndex >= gNumRecords-1 )
    {
        gPlaybackIndex = 0;
        gPlaybackTime = 0.0;
    }

    if ( gPlaybackTime >= (gRecords[gPlaybackIndex+1][0].rtime / 100.0 - gRaceStartTime) )
    {
        gPlaybackIndex++;
    }

    mvutils_avg360_reset( gTwdAvg );

    // Assemble the array of data points for each boat
    for (var i = 0; i < numBoats; i++)
    {
        var subRec = getRecordAtTimeForBoat( gPlaybackTime, gBoatIdList[i] );

        rec.push(subRec);

        mvutils_avg360_add( gHdmAvgPerBoat[i], subRec.hdm );

        // Adjust target angles and point of sail based on fixed 50º / 135º angles
        if ( i === gSelectedBoatIndex )
        {
            mvutils_avg360_add( gTwdAvg, (subRec.dampTwd !== 999999 ? subRec.dampTwd : gTwdAvg.avg) );
            gTwaTgt = Math.abs( subRec.twaTgt );
            if ( gTwaTgt < 35 )
            {
                //console.log('ooo');
            }
            markIdx = subRec.legIdx;

            if ( gLegs !== null && gLegs.length > 0 && rec[i].legIdx !== undefined && rec[i].legIdx < gLegs.length )
            {
                legHdm = gLegs[rec[i].legIdx].legHdm;

                if ( Math.abs(mvutils_substract360(subRec.dampTwd, legHdm - subRec.magvar)) > 135 )
                {
                    gTwaTgtPointOfSail = kNextMarkIsDownwind;
                }
                else if ( Math.abs(mvutils_substract360(subRec.dampTwd, legHdm - subRec.magvar)) < 50 )
                {
                    gTwaTgtPointOfSail = kNextMarkIsUpwind;
                }
                else
                {
                    gTwaTgtPointOfSail = kNextMarkIsReaching;
                }
            }
            else
            {
                // We have no legs (i.e. no course)
                gTwaTgtPointOfSail = kNextMarkIsReaching;
            }

            if ( Math.abs( gTwaTgt ) < 90 )
            {
                if ( gTwaTgt < 35 )
                {
                    //console.log('ooo');
                }
                gTwaTgtUp = gTwaTgt;
                mvutils_avg360_add( gTwaTgtUpAvg, gTwaTgtUp );
            }
            else
            {
                gTwaTgtDown = gTwaTgt;
                mvutils_avg360_add( gTwaTgtDownAvg, gTwaTgtDown );
            }
        }

        if ( logCnt++ == 0 )
        {
            //console.log('Boat ' + subRec.boat_id + ' | TWD = ' + gTwd + ' | xMark = ' + gXName + ' | xHdm = ' + subRec.xHdm + ' | ' + (gTwaTgtPointOfSail ? 'up' : 'down') );
        }
        logCnt %= 30;
    }

    mvutils_avg360_add( gTwdDisplayAvg, gTwdAvg.avg );
    mvutils_avg360_add( gTwdCameraAvg, gTwdAvg.avg );
    gTwd = gTwdDisplayAvg.avg;

    windIndicatorUpdate();

    return { recList: rec, nextMarkIdx: markIdx };
}

function getRecordAtTimeForBoat( playtime, boatId )
{
    var interpolatedRec = null;
    var rec1 = null;
    var rec2 = null;

    // Step 1: Find the closest record previous to playtime that contains this boat ID.
    // Allow 11 record-steps to accommodate a 1Hz and a 10Hz sampling boat in the same data set.
    for ( var index = gPlaybackIndex; index > gPlaybackIndex-11 && index >= 0; index-- )
    {
        for ( var r=0; r<gRecords[index].length; r++ )
        {
            if ( gRecords[index][r].boat_id === boatId && gRecords[index][r].lat !== 0 && gRecords[index][r].lon !== 0 )
            {
                rec1 = gRecords[index][r];
                break;
            }
        }

        if ( rec1 != null ) break;
    }

    // Step 2: Find the next record that contains this boat ID
    for ( index = gPlaybackIndex+1; index < gPlaybackIndex+12 && index < gNumRecords; index++ )
    {
        for ( var r=0; r<gRecords[index].length; r++ )
        {
            if ( gRecords[index][r].boat_id === boatId && gRecords[index][r].lat !== 0 && gRecords[index][r].lon !== 0 )
            {
                rec2 = gRecords[index][r];
                break;
            }
        }

        if ( rec2 != null ) break;
    }

    // Step 3: Interpolate between the rtime's we found for this boat and the current playtime
    if ( rec1 != null && rec2 != null )
    {
        // Interpolate position, heading, and wind data for smooth animations
        recDelta = rec2.rtime / 100.0 - rec1.rtime / 100.0;
        recOffset = gPlaybackTime - (rec1.rtime / 100.0 - gRaceStartOffset[r] - gRaceStartTime);

        if ( recOffset >= 0 )
        {
            // Use rec1 as a baseline - make a copy so we don't change the original data!
            interpolatedRec = {};
            interpolatedRec.boat_id = rec1.boat_id;
            interpolatedRec.lat = rec1.lat;
            interpolatedRec.lon = rec1.lon;
            interpolatedRec.racetime = rec1.racetime;
            interpolatedRec.rcount = rec1.rcount;
            interpolatedRec.rtime = rec1.rtime;
            interpolatedRec.stw = rec1.stw;
            interpolatedRec.vmg = rec1.vmg;
            interpolatedRec.vmc = rec1.vmc;
            interpolatedRec.twa = rec1.twa;
            interpolatedRec.tws = rec1.tws;
            interpolatedRec.twaTgt = rec1.twaTgt;
            interpolatedRec.heel = rec1.heel;
            interpolatedRec.magvar = rec1.magvar;
            interpolatedRec.legIdx = rec1.legIdx;
            interpolatedRec.xName = rec1.xName;
            interpolatedRec.xHdm = rec1.xHdm;
            interpolatedRec.xDist = rec1.xDist;

            interpolatedRec.lat += (rec2.lat - rec1.lat) * recOffset / recDelta;
            interpolatedRec.lon += (rec2.lon - rec1.lon) * recOffset / recDelta;
            interpolatedRec.hdm = mvutils_add360(rec1.hdm,
                mvutils_substract360(rec2.hdm, rec1.hdm) * recOffset / recDelta);
            interpolatedRec.dampTwd = mvutils_add360(rec1.dampTwd,
                mvutils_substract360(rec2.dampTwd, rec1.dampTwd) * recOffset / recDelta);
            if ( isNaN(interpolatedRec.dampTwd) )
            {
                //console.log('ooo');
            }

            // Interpolate TWA targets only while they are both up- or downwind
            if ( Math.abs( rec1.twaTgt - rec2.twaTgt ) < 45 )
            {
                interpolatedRec.twaTgt = mvutils_add360(rec1.twaTgt,
                    mvutils_substract360(rec2.twaTgt, rec1.twaTgt) * recOffset / recDelta);
            }
            else
            {
                interpolatedRec.twaTgt = rec1.twaTgt;
            }
        }
        else
        {
            interpolatedRec = { boat_id: boatId, lat: 0, lon: 0 };
        }
    }
    else
    {
        interpolatedRec = { boat_id: boatId, lat: 0, lon: 0 };
    }

    return interpolatedRec;
}

function getPastPositionForBoat( delay, boatId )
{
    var index;
    var recFound = false;

    for ( index = gPlaybackIndex; index > 1; index-- )
    {
        if ( gRecords[index][boatId].lat !== 0
             &&
             gRecords[index][boatId].lon !== 0
             &&
             gPlaybackTime - (gRecords[index][gSelectedBoatIndex].rtime/100.0 - gRaceStartOffset[gSelectedBoatIndex] -gRaceStartTime) >= delay )
        {
            recFound = true;
            break;
        }
    }

    // Need to interpolate based on fractional delay
    if ( recFound )
    {
        var prevIndex;
        var prevRecFound = false;

        for ( prevIndex = index-1; prevIndex > 1; prevIndex-- )
        {
            if ( gRecords[prevIndex][boatId].lat != 0
                 &&
                 gRecords[prevIndex][boatId].lon != 0 )
            {
                prevRecFound = true;
                break;
            }
        }

        if ( prevRecFound )
        {
            var recDelta = gRecords[index][boatId].rtime / 100.0 - gRecords[prevIndex][boatId].rtime / 100.0;
            var fraction = (gPlaybackTime - (gRecords[index][boatId].rtime / 100.0 - gRaceStartOffset[boatId] - gRaceStartTime) - delay) / recDelta;
            var deltaLat = (gRecords[index][boatId].lat - gRecords[prevIndex][boatId].lat) * fraction;
            var deltaLon = (gRecords[index][boatId].lon - gRecords[prevIndex][boatId].lon) * fraction;

            var pos = translate(gRecords[prevIndex][boatId].lat + deltaLat,
                gRecords[prevIndex][boatId].lon + deltaLon);

            //console.log('CAM-POS, '+ pos.x + ', ' + pos.y + ', ' + deltaLat + ', ' + deltaLon + ', ' + fraction + ', ' + index);
        }
        else
        {
            var pos = translate(gRecords[index][boatId].lat,
                gRecords[index][boatId].lon);
        }
        return pos;
    }

    return translate(gRecords[index][boatId].lat,
        gRecords[index][boatId].lon );
}

/* ==============================================================
   SCENE CREATION
   ============================================================== */
function loadScene()
{
    var sceneElement = document.getElementById('scene-canvas');

    gScene = new THREE.Scene();
    //scene.background = new THREE.Color( 0x2020a0 );

    gCamera = new THREE.PerspectiveCamera( 30, sceneElement.scrollWidth / sceneElement.scrollHeight, 0.1, 100 );

    //loadOcean( gScene );

    loadSky( gScene );

    // Create boats
    gBoats = new Array();
    gEgoModel = new Array();
    gBoatTrails = new Array();
    gBoatTrailIndex = new Array();
    gBoatAnnotations = new Array();
    var loadingManager = new Array();
    var loader = new Array();
    for (var i = 0; i < numBoats; i++)
    {
        gHdmAvgPerBoat.push( mvutils_avg360_init( gHdmDampTime ));

        // Step 1: Load boat ego models
        // Three.js loading manager
        loadingManager.push( new THREE.LoadingManager(function () {
            // Tricky - since the loader is async and we don't know in which order they complete,
            // wait until the ego model array is full and then initialize all of them:
            if ( gEgoModel.length === numBoats )
            {
                for ( var b=0; b<numBoats; b++ )
                {
                    var xOffset = -kEgoFullSizeFactor * 3.75;   // -0.15 at 0.04 scale
                    gEgoModel[b].scale.set( kEgoFullSizeFactor, kEgoFullSizeFactor, kEgoFullSizeFactor );
                    gEgoModel[b].position.x = xOffset;
                    gEgoModel[b].rotation.x = 0.0;
                    gEgoModel[b].rotation.y = 0.0;

                    // Create a pivot point for the boat so we turn around the center
                    var pivot = new THREE.Object3D();
                    pivot.add(gEgoModel[b]);
                    pivot.scale.set( kEgoScaleBev, kEgoScaleBev, kEgoScaleBev );
                    pivot.name = 'BOAT ' + b;

                    gScene.add(pivot);
                    gBoats.push(pivot);

                    gAllElementsLoaded = true;
                }

            }
        }) );

        // Collada model
        loader.push( new THREE.ColladaLoader(loadingManager[i]) );
        loader[i].load(gAssetPrefix + '/dae/ego-boat.dae', function( collada ) {
            gEgoModel.push( collada.scene );
        });

        // Step 2: Create boat trail array
        var bTrail = new Array();
        for ( var t=0; t<gBoatTrailSize; t++ )
        {
            var geometry = new THREE.CircleGeometry( gBoatTrailSpotSize, 32 );
            var material = new THREE.MeshLambertMaterial( { color: kTrailColors[i%kTrailColors.length] } );
            material.transparent = true;
            material.opacity = 1.0;
            var circle = new THREE.Mesh( geometry, material );
            circle.position.z = -99999;
            circle.name = 'TRACK ' + i;
            gScene.add( circle );
            bTrail.push( circle );
        }
        gBoatTrails.push( bTrail );
        gBoatTrailIndex.push( {index: 0, time: 0} );

        // Step 3: Create boat annotation DIVs
        var annotationDiv = document.createElement('div');
        annotationDiv.id = 'boat-annotation-' + i;
        annotationDiv.style.position = 'absolute';
        annotationDiv.style.width = 100;
        //annotationDiv.style.height = 75;
        annotationDiv.style.borderLeftStyle = 'solid';
        annotationDiv.style.borderLeftColor = '#FFF';
        annotationDiv.style.borderLeftWidth = '1.5px';
        annotationDiv.style.paddingLeft = '5px';
        annotationDiv.style.bottom = 0 + 'px';
        annotationDiv.style.left = 0 + 'px';
        annotationDiv.style.color = '#FFF';
        annotationDiv.style.textShadow = '0 0 5px rgba(0, 0, 0, 0.8)';
        annotationDiv.lineHeight = '14px';
        annotationDiv.whiteSpace = 'pre-line';
        annotationDiv.classList.add('boat-annotation-group');
        document.getElementById('scene').appendChild( annotationDiv );
    }
    $('.boat-annotation-group').height( 72 );

    gCamera.position.set( 0, -kCameraPlaneGeoDistance, kCameraPlaneHeightDistance );
    gCamera.up = new THREE.Vector3(0,0,1);
    gCamera.lookAt( new THREE.Vector3(gScene.position.x, gScene.position.y, gScene.position.z + kCameraLookAtOffset) );

    var ambientLight = new THREE.AmbientLight( 0xcccccc, 0.6 );
    gScene.add( ambientLight );

    var directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
    directionalLight.position.set( -1, 1, 10 );
    gScene.add( directionalLight );

    gRenderer = new THREE.WebGLRenderer( { antialias: true } );
    gRenderer.setSize( sceneElement.scrollWidth, sceneElement.scrollHeight );
    sceneElement.appendChild( gRenderer.domElement );

    document.getElementById('scene-controls').style.opacity = 1.0;
    document.getElementById('scene-boat-legend').style.opacity = 1.0;

    var controls = new THREE.OrbitControls( gCamera, gRenderer.domElement );
    controls.enabled = false;

    gCamera.lookAt( new THREE.Vector3(gScene.position.x, gScene.position.y, gScene.position.z + kCameraLookAtOffset) );
}

function loadGeoMap( ctrLat, ctrLon, zoom, demo )
{
    // Load gmaps satellite overlay as surface texture and terrain map w/o labels as water area mask
    var waterThreshold = 0.85;
    //var mapSrc = 'https://maps.googleapis.com/maps/api/staticmap?size=600x600&center=' + ctrLat.toFixed(6) + '%2C' + ctrLon.toFixed(6) + '&zoom=' + zoom + '&maptype=satellite&format=jpg&scale=2&key=' + kGmapsKey;
    //var flowMaskSrc = site.uri.public + '/api/sailcast' + (rShareToken === '' ? '' : '-shared') + '/flow-map?lat=' + ctrLat.toFixed(6) + '&lon=' + ctrLon.toFixed(6) + '&zoom=' + zoom + '&ts=' + waterThreshold + (rShareToken === '' ? '' : '&tk=' + rShareToken);
    var mapSrc = site.uri.public + '/api/sailcast' + (rShareToken === '' ? '' : '-shared') + '/geo-map?lat=' + ctrLat.toFixed(6) + '&lon=' + ctrLon.toFixed(6) + '&zoom=' + zoom + '&ts=' + waterThreshold + (rShareToken === '' ? '' : '&tk=' + rShareToken);

    if ( demo )
    {
        // The demo is a W/L on the ocean, don't waste time looking for the map
        gGeoTexturesLoaded = true;
    }
    else
    {
        loadGeoSurface(gScene, mapSrc);
    }

    //loadOcean( gScene, mapSrc, flowMaskSrc );
    loadOceanSurface( gScene );
    loadWaterSurface( gScene );
    loadWindIndicator( gScene );
    loadWindSpeedInd( gScene );
}

function loadGeoSurface( scene, mapUrl )
{
    if ( mapUrl === undefined || mapUrl == null )
    {
        return;
    }

    var geoGeometry = new THREE.PlaneBufferGeometry( kOceanSize, kOceanSize );
    var geoMaterial = new THREE.MeshStandardMaterial( { roughness: 0.0, metalness: 0.0 } );
    var geoMesh = new THREE.Mesh( geoGeometry, geoMaterial );
    geoMesh.position.z = gGeoOverlayLevel;
    geoMesh.name = 'MAP';

    // Load the gmap satellite map
    var textureLoader = new THREE.TextureLoader();
    textureLoader.load( mapUrl,
        function ( map ) {
            map.wrapS = THREE.ClampToEdgeWrapping;
            map.wrapT = THREE.ClampToEdgeWrapping;
            map.anisotropy = 16;
            map.repeat.set( 1, 1 );
            geoMaterial.map = map;
            geoMaterial.transparent = true;
            geoMaterial.alphaTest = 0.1;
            geoMaterial.needsUpdate = true;

            scene.add( geoMesh );

            gGeoTexturesLoaded = true;
            $('#google-maps-copyright').show();
        },

        // onProgress callback currently not supported
        undefined,

        // onError callback
        function ( err ) {
            // We don't have a flowmap since the area is mostly water - we are done loading
            geoMesh = null;
            gGeoTexturesLoaded = true;
        } );
}

function loadOceanSurface( scene )
{
    var oceanGeometry = new THREE.PlaneBufferGeometry( kOceanSize, kOceanSize );
    var oceanMaterial = new THREE.MeshStandardMaterial( { roughness: 0.0, metalness: 0.0 } );
    var ocean = new THREE.Mesh( oceanGeometry, oceanMaterial );
    ocean.position.z = gWaterLevel-0.01;
    ocean.name = 'OCEAN';
    //ocean.layers.enable( 1 );
    scene.add( ocean );

    // Load the default water surface
    var textureLoader = new THREE.TextureLoader();
    textureLoader.load( gAssetPrefix + '/img/tx-water-surface-dark.jpg',
        function ( map ) {
            map.wrapS = THREE.RepeatWrapping;
            map.wrapT = THREE.RepeatWrapping;
            map.anisotropy = 16;
            map.repeat.set( 1, 1 );
            oceanMaterial.map = map;
            oceanMaterial.needsUpdate = true;

            gOceanTexturesLoaded = true;
        } );
}

function loadWaterSurface( scene )
{
    var waterGeometry = new THREE.PlaneBufferGeometry(kOceanSize, kOceanSize);
    water = new THREE.Water(waterGeometry, {
        color: '#abc0da',
        reflectivity: 0.001,
        clipBias: 0.003,
        scale: 10.0,
        flowSpeed: 0.05,
        flowDirection: new THREE.Vector2(0, 1),
        textureWidth: 640,
        textureHeight: 640
    });
    water.position.z = gWaterLevel;
    water.name = 'WATER';
    scene.add(water);
}

function loadSky( scene )
{
    // skybox
    var cubeTextureLoader = new THREE.CubeTextureLoader();
    cubeTextureLoader.setPath( gAssetPrefix + '/img/' );
    var cubeTexture = cubeTextureLoader.load( [
        'px.jpg', 'nx.jpg',
        'py.jpg', 'ny.jpg',
        'pz.jpg', 'nz.jpg',
    ] );
    var cubeShader = THREE.ShaderLib[ 'cube' ];
    cubeShader.uniforms[ 'tCube' ].value = cubeTexture;
    var skyBoxMaterial = new THREE.ShaderMaterial( {
        fragmentShader: cubeShader.fragmentShader,
        vertexShader: cubeShader.vertexShader,
        uniforms: cubeShader.uniforms,
        side: THREE.BackSide
    } );
    var skyBox = new THREE.Mesh( new THREE.BoxBufferGeometry( 1000, 1000, 1000 ), skyBoxMaterial );
    skyBox.layers.enable( 1 );
    skyBox.name = 'SKYBOX';
    scene.add( skyBox );
}

function geometryCloneFaces( geometry )
{
    for (var i = 0, len = geometry.faces.length; i < len; i++)
    {
        var face = geometry.faces[i].clone();
        face.materialIndex = 1;
        geometry.faces.push(face);
        geometry.faceVertexUvs[0].push(geometry.faceVertexUvs[0][i].slice(0));
    }
}

function loadWindIndicator( scene )
{
    var geometry1 = new THREE.PlaneGeometry( 3, 3 );
    var material1 = new THREE.MeshPhongMaterial( {side: THREE.FrontSide} );
    gWindIndRing = new THREE.Mesh( geometry1, material1 );
    gWindIndRing.name = 'WIND RING';
    scene.add( gWindIndRing );

    var textureLoader1 = new THREE.TextureLoader();
    textureLoader1.load( gAssetPrefix + '/img/tx-wind-indicator-ring.png',
        function ( map ) {
            map.wrapS = THREE.ClampToEdgeWrapping;
            map.wrapT = THREE.ClampToEdgeWrapping;
            map.anisotropy = 16;
            map.repeat.set( 1, 1 );
            material1.map = map;
            material1.transparent = true;
            material1.alphaTest = 0.1;
            material1.needsUpdate = true;

            gWindIndRing.position.z = gWindIndLevel;
        } );

    var geometry2 = new THREE.PlaneBufferGeometry( 3, 3 );
    var material2 = new THREE.MeshPhongMaterial();
    gWindIndAvg = new THREE.Mesh( geometry2, material2 );
    gWindIndAvg.name = 'WIND AVG';
    scene.add( gWindIndAvg );

    var textureLoader2 = new THREE.TextureLoader();
    textureLoader2.load( gAssetPrefix + '/img/tx-wind-indicator-avg.png',
        function ( map ) {
            map.wrapS = THREE.ClampToEdgeWrapping;
            map.wrapT = THREE.ClampToEdgeWrapping;
            map.anisotropy = 16;
            map.repeat.set( 1, 1 );
            material2.map = map;
            material2.transparent = true;
            material2.alphaTest = 0.1;
            material2.needsUpdate = true;

            gWindIndAvg.position.z = gWindIndLevel;
        } );

    var geometry3 = new THREE.PlaneBufferGeometry( 3, 3 );
    var material3 = new THREE.MeshPhongMaterial();
    gWindIndCurrent = new THREE.Mesh( geometry3, material3 );
    gWindIndCurrent.name = 'WIND CURRENT';
    scene.add( gWindIndCurrent );

    var textureLoader3 = new THREE.TextureLoader();
    textureLoader3.load( gAssetPrefix + '/img/tx-wind-indicator-current.png',
        function ( map ) {
            map.wrapS = THREE.ClampToEdgeWrapping;
            map.wrapT = THREE.ClampToEdgeWrapping;
            map.anisotropy = 16;
            map.repeat.set( 1, 1 );
            material3.map = map;
            material3.transparent = true;
            material3.alphaTest = 0.1;
            material3.needsUpdate = true;

            gWindIndCurrent.position.z = gWindIndLevel + 0.005;
        } );
}

var gWindSpeedUpdateHold = false;

function windIndicatorUpdate()
{
    // Rotation is defined left-handed, so rotate by the negative wind direction
    if ( gWindIndAvg !== null && gWindIndCurrent !== null )
    {
        if ( Math.abs(gTwdCameraAvg.avg - gWindIndAvgValue) > 0.5 )
        {
            gWindIndAvgValue = gTwdCameraAvg.avg;
            gWindIndAvg.rotation.z = ((-gWindIndAvgValue) * kDegToRad);
        }
        if ( gTwd !== 999999.0 && Math.abs(gTwd - gWindIndCurrentValue) > 0.5 )
        {
            gWindIndCurrentValue = gTwd;
            gWindIndCurrent.rotation.z = ((-gWindIndCurrentValue) * kDegToRad);
        }
    }

    // Update the text for the wind speed
    if ( gWindSpeedText !== null && !gWindSpeedUpdateHold && gTws !== '999999.0' )
    {
        gWindSpeedUpdateHold = true;

        var textGeometry = new THREE.TextGeometry( gTws + '',
            {
                font: gWindSpeedFont,
                size: 0.3,
                height: 0.03,
                curveSegments: 12,
                bevelEnabled: false
            });
        textGeometry.computeBoundingBox();
        var tSize = textGeometry.boundingBox.getSize();
        textGeometry.translate( -(tSize.x / 1.9), -(1.2 * tSize.y), 0 );

        gWindSpeedText.geometry = textGeometry;
        gWindSpeedText.rotation.z = ((-gWindIndAvgValue) * kDegToRad);
        gWindSpeedUnit.rotation.z = ((-gWindIndAvgValue) * kDegToRad);

        setTimeout( function() { gWindSpeedUpdateHold = false; }, 450 );
    }
}

function windIndicatorShow()
{
    gWindIndRing.position.z = gWindIndLevel;
    gWindIndAvg.position.z = gWindIndLevel;
    gWindIndCurrent.position.z = gWindIndLevel + 0.005;
    gWindSpeedText.position.z = gWindIndLevel;
    gWindSpeedUnit.position.z = gWindIndLevel;
}

function windIndicatorHide()
{
    gWindIndRing.position.z = 0.0;
    gWindIndAvg.position.z = 0.0;
    gWindIndCurrent.position.z = 0.0;
    gWindSpeedText.position.z = 0.0;
    gWindSpeedUnit.position.z = 0.0;
}

function loadWindSpeedInd( scene )
{
    var loader = new THREE.FontLoader();
    loader.load( gAssetPrefix + '/fonts/helvetiker_bold.typeface.json', function ( font ) {
        gWindSpeedFont = font;

        var textGeometry = new THREE.TextGeometry( ' ',
            {
                font: gWindSpeedFont,
                size: 0.3,
                height: 0.003,
                curveSegments: 12
            });

        var textMaterial = new THREE.MeshPhongMaterial(
            { color: 0x909090, specular: 0xffffff }
        );

        gWindSpeedText = new THREE.Mesh( textGeometry, textMaterial );
        gWindSpeedText.position.z = gWindIndLevel;
        gWindSpeedText.name = 'TWS VALUE';

        scene.add( gWindSpeedText );

        var unitGeometry = new THREE.TextGeometry( 'kn',
            {
                font: gWindSpeedFont,
                size: 0.18,
                height: 0.003,
                curveSegments: 12
            });
        unitGeometry.computeBoundingBox();
        var uSize = unitGeometry.boundingBox.getSize();
        unitGeometry.translate( -(uSize.x / 2.0), -(3.3 * uSize.y), 0 );


        gWindSpeedUnit = new THREE.Mesh( unitGeometry, textMaterial );
        gWindSpeedUnit.position.z = gWindIndLevel;
        gWindSpeedUnit.name = 'TWS UNIT';

        scene.add( gWindSpeedUnit );
    });
}

function loadCourseMarks( scene )
{
    gMarkCones = new Array();
    gMarkAnnotations = new Array();
    gLegs = new Array();
    var coneMaterials = new Array();

    for ( var i = 0; i < gMarks.length; i++ )
    {
        var geometry = new THREE.ConeGeometry( kMarkConeRadius, kMarkConeHeight, 20, 20 );
        var material = new THREE.MeshBasicMaterial( { color: 0xfff200 } );
        var cone = new THREE.Mesh( geometry, material );
        cone.name = 'MARK: ' + gMarks[i].name;
        scene.add( cone );
        gMarkCones.push( cone );
        coneMaterials.push( material );

        var pos = translate( gMarks[i].lat, gMarks[i].lon );
        cone.position.x = pos.x;
        cone.position.y = pos.y;
        cone.position.z = gWaterLevel + 0.01;
        cone.rotation.x = 90.0 * kDegToRad;

        if ( (gMarks[i].index === 0 && gMarks[i].name === 'Start') || gMarks[i].index > 0 )
        {
            gMarkAnnotations.push( {x:cone.position.x, y:cone.position.y, z:cone.position.z + 0.05, index: gMarks[i].index} );
            gLegs.push( {lat: gMarks[i].lat, lon: gMarks[i].lon} );
        }
    }
    var textureLoader = new THREE.TextureLoader();
    textureLoader.load( gAssetPrefix + '/img/tx-course-mark.png',
        function ( map ) {
            map.wrapS = THREE.ClampToEdgeWrapping;
            map.wrapT = THREE.ClampToEdgeWrapping;
            map.anisotropy = 16;
            map.repeat.set( 1, 1 );
            for ( var i = 0; i < coneMaterials.length; i++ )
            {
                coneMaterials[i].map = map;
                coneMaterials[i].transparent = true;
                coneMaterials[i].alphaTest = 0.1;
                coneMaterials[i].needsUpdate = true;
            }
        } );

    // Update scale of mark cones
    for ( i=0; i<gMarkCones.length; i++ )
    {
        gMarkCones[i].scale.set( gMarkScale, gMarkScale, gMarkScale );
    }

    // Get the magn. variation
    var magvar = 0.0;
    for ( i=0; i<gRecords[0].length; i++ )
    {
        if ( gRecords[0][i].lat !== 0 && gRecords[0][i].lon !== 0 )
        {
            magvar = gRecords[0][i].magvar;
            break;
        }
    }

    // Calculate leg information
    for ( i=1; i<gLegs.length; i++ )
    {
        var xhdt = mvutils_calculate_xhdm( {lat: gLegs[i-1].lat, lon: gLegs[i-1].lon},
                                           {lat: gLegs[i].lat, lon: gLegs[i].lon} );
        var xhdm = mvutils_add360( xhdt, -magvar );
        var xdist = mvutils_distanceFromTo( gLegs[i-1].lat, gLegs[i-1].lon, gLegs[i].lat, gLegs[i].lon ) * 1852.0;

        gLegs[i].legHdm = xhdm;
        gLegs[i].legDist = xdist;
    }
    // Remove start entry from legs
    gLegs.shift();

    gMarksLoaded = true;
}

/* ==============================================================
   RACE DATA DOWNLOAD
   ============================================================== */
function downloadRaceData( demo )
{
    if ( raceInfos == null ) return;

    // Allow a bigger canvas for demo mode
    if ( demo )
    {
        kOceanSize -= 5;
    }

    var data = new Object();
    var url;
    if ( demo )
    {
        /// SINGLE RACE: url = gAssetPrefix + '/logs/records-53.json';
        url = gAssetPrefix + '/logs/records-53-64.json';
    }
    else
    {
        data[site.csrf.keys.name] = site.csrf.name;
        data[site.csrf.keys.value] = site.csrf.value;

        if ( rShareToken == '' )
        {
            url = site.uri.public + '/api/sailcast/records?race=';
            for ( var i=0; i<raceInfos.length-1; i++ )
            {
                url += raceInfos[i].raceId + ',';
            }
            url += raceInfos[raceInfos.length-1].raceId;
        }
        else
        {
            url = site.uri.public + '/api/sailcast-shared/records?race=' + rShareToken;
        }
    }

    var debugAjax = (typeof site !== "undefined") && site.debug.ajax;

    return $.ajax({
        type: "GET",
        url: url,
        data: data,
        dataType: 'json'
    }).fail(function (jqXHR) {
        if ( jqXHR.status == 200 )
        {
            console.log("Race data downloaded successfully.");
        }
        else
        {
            // Error messages
            if (debugAjax && jqXHR.responseText) {
                document.write(jqXHR.responseText);
                document.close();
            } else {
                console.log("Error (" + jqXHR.status + "): " + jqXHR.responseText );
            }
            // Display errors on failure
            // TODO: ufAlerts widget should have a 'destroy' method
            if (!$("#alerts-page").data('ufAlerts')) {
                $("#alerts-page").ufAlerts();
            } else {
                $("#alerts-page").ufAlerts('clear');
            }

            $("#alerts-page").ufAlerts('fetch').ufAlerts('render');
        }

        return jqXHR;
    }).done(function (response) {
        //console.log( response );
        gRecords = response;
        var gotRaceData = false;

        if ( gRecords != null )
        {
            // See how many we have and get start time and duration
            gNumRecords = gRecords.length;
            if ( gNumRecords > 10 )
            {
                // Calculate play times for challenge races (different start times)
                gPlaybackIndex = 0;
                gRaceStartTime = gRecords[0][0].rtime / 100.0;
                if ( raceInfos[0].regattaType === 2 )
                {
                    // Challenge replay - find start time offsets, raceInfo is sorted by duration (long -> short)
                    for ( var i = 1; i < gRecords[0].length; i++ )
                    {
                        gRaceStartTime = Math.min(gRaceStartTime, gRecords[0][i].rtime / 100.0);
                    }
                    for ( var i = 0; i < gRecords[0].length; i++ )
                    {
                        var thisRaceLogStart = gRecords[0][i].rtime / 100.0
                        gRaceStartOffset.push(thisRaceLogStart - gRaceStartTime);
                        console.log('Start offset for race ' + i + ': ' + thisRaceLogStart - gRaceStartTime);
                    }

                    var endIdx = gNumRecords - 1;
                    while ( gRecords[endIdx--][0].race_id !== gRecords[0][0].race_id ) ;
                    gRaceDuration = (gRecords[endIdx][0].rtime - gRecords[0][0].rtime) / 100.0;
                    gFirstMarkRaceTimeOffset = 0;
                }
                else
                {
                    // In a regular race all boats start at the same time
                    for ( var i = 0; i<raceInfos.length; i++ )
                    {
                        gRaceStartOffset.push(0.0);
                    }
                    gFirstMarkRaceTimeOffset = -gRecords[gSelectedBoatIndex][gReferenceMarkListIndex].racetime;
                }

                // Maintain each boat's current leg index so we can determine the lead boat
                for ( var i = 0; i<raceInfos.length; i++ )
                {
                    raceInfos[i].legIdx = 0;
                    raceInfos[i].legXMark = null;
                    raceInfos[i].constructedMarkList = [];

                    // Initialize the last info to 0
                    raceInfos[i].lastLat = 0.0;
                    raceInfos[i].lastLon = 0.0;
                    raceInfos[i].lastHdm = 0.0;
                    raceInfos[i].lastStw = 0.0;
                    raceInfos[i].lastVmg = 0.0;
                    raceInfos[i].lastVmc = 0.0;
                    raceInfos[i].lastTws = 0.0;
                    raceInfos[i].lastTwa = 0.0;
                    raceInfos[i].lastHeel = 0.0;
                    raceInfos[i].lastDampTwd = 0.0;
                    raceInfos[i].lastTwaTgt = 0.0;
                    raceInfos[i].lastXName = '';
                    raceInfos[i].lastXHdm = 0.0;
                    raceInfos[i].lastXDist = 0.0;
                }

                // Adjust array to contain at least one entry per boat per rtime. When we encounter missing records (zero records)
                // fill in the most recent data known.
                var latMin = 90.0, latMax = -90.0, lonMin = 180.0, lonMax = -180.0;
                for ( var r = 0; r < gNumRecords; r++ )
                {
                    if ( gRecords[r].length !== raceInfos.length )
                    {
                        var recIndex = 0;
                        var tempArray = new Array();
                        for ( var i = 0; i < raceInfos.length; i++ )
                        {
                            // Build existing race records into an array at race time 'r' in the order of the race infos
                            if ( recIndex < gRecords[r].length
                                 &&
                                 gRecords[r][recIndex].race_id === raceInfos[i].raceId )
                            {
                                tempArray.splice(i, 0, gRecords[r][recIndex]);
                                if ( gRecords[r][recIndex].lat !== 0 && gRecords[r][recIndex].lon !== 0 )
                                {
                                    raceInfos[i].lastLat = gRecords[r][recIndex].lat;
                                    raceInfos[i].lastLon = gRecords[r][recIndex].lon;
                                    raceInfos[i].lastHdm = gRecords[r][recIndex].hdm;
                                    raceInfos[i].lastStw = gRecords[r][recIndex].stw;
                                    raceInfos[i].lastVmg = gRecords[r][recIndex].vmg;
                                    raceInfos[i].lastVmc = gRecords[r][recIndex].vmc;
                                    raceInfos[i].lastTws = gRecords[r][recIndex].tws;
                                    raceInfos[i].lastTwa = gRecords[r][recIndex].twa;
                                    raceInfos[i].lastHeel = gRecords[r][recIndex].heel;
                                    raceInfos[i].lastDampTwd = gRecords[r][recIndex].dampTwd;
                                    raceInfos[i].lastTwaTgt = gRecords[r][recIndex].twaTgt;
                                    raceInfos[i].lastXName = gRecords[r][recIndex].xName;

                                    // xHdm and xDist are not always valid
                                    if ( !isNaN(gRecords[r][recIndex].xHdm) && gRecords[r][recIndex].xHdm !== 999999 )
                                        raceInfos[i].lastXHdm = gRecords[r][recIndex].xHdm;
                                    if ( !isNaN(gRecords[r][recIndex].xDist) && gRecords[r][recIndex].xDist > 0 )
                                        raceInfos[i].lastXDist = gRecords[r][recIndex].xDist;

                                    latMin = Math.min(latMin, raceInfos[i].lastLat);
                                    latMax = Math.max(latMax, raceInfos[i].lastLat);
                                    lonMin = Math.min(lonMin, raceInfos[i].lastLon);
                                    lonMax = Math.max(lonMax, raceInfos[i].lastLon);
                                }

                                recIndex++;
                            }
                            else
                            {
                                if ( raceInfos[i].lastLat === undefined )
                                {
                                    // We have a race index whose records begin past the beginning
                                    raceInfos[i].lastLat = 0;
                                    raceInfos[i].lastLon = 0;
                                }

                                // The original data set has at least one raceIndex per time 'r', so gRecords[r][0] is always a valid object.
                                // Find which raceIndex is contained in record 0 so we can use the correct start time offset:
                                var raceIdx;
                                for ( raceIdx = 0; raceIdx < raceInfos.length; raceIdx++ )
                                {
                                    if ( raceInfos[raceIdx].boatId === gRecords[r][0].boat_id )
                                    {
                                        break;
                                    }
                                }
                                tempArray.splice(i, 0,
                                    {
                                        race_id: raceInfos[i].raceId,
                                        boat_id: raceInfos[i].boatId,
                                        rtime: (gRecords[r][0].rtime / 100.0 - gRaceStartOffset[raceIdx] + gRaceStartOffset[i]) * 100.0,
                                        lat: raceInfos[i].lastLat,
                                        lon: raceInfos[i].lastLon,
                                        hdm: raceInfos[i].lastHdm,
                                        stw: raceInfos[i].lastStw,
                                        vmg: raceInfos[i].lastVmg,
                                        vmc: raceInfos[i].lastVmc,
                                        tws: raceInfos[i].lastTws,
                                        twa: raceInfos[i].lastTwa,
                                        heel: raceInfos[i].lastHeel,
                                        dampTwd: raceInfos[i].lastDampTwd,
                                        twaTgt: raceInfos[i].lastTwaTgt,
                                        magvar: gRecords[r][0].magvar,
                                        xName: raceInfos[i].lastXName,
                                        xHdm: raceInfos[i].lastXHdm,
                                        xDist: raceInfos[i].lastXDist
                                    });
                            }
                        }
                        gRecords[r] = tempArray;
                    }
                    else
                    {
                        for ( var i = 0; i < raceInfos.length; i++ )
                        {
                            if ( gRecords[r][i].lat !== 0 && gRecords[r][i].lon !== 0 )
                            {
                                raceInfos[i].lastLat = gRecords[r][i].lat;
                                raceInfos[i].lastLon = gRecords[r][i].lon;
                                raceInfos[i].lastHdm = gRecords[r][i].hdm;
                                raceInfos[i].lastStw = gRecords[r][i].stw;
                                raceInfos[i].lastVmg = gRecords[r][i].vmg;
                                raceInfos[i].lastVmc = gRecords[r][i].vmc;
                                raceInfos[i].lastTws = gRecords[r][i].tws;
                                raceInfos[i].lastTwa = gRecords[r][i].twa;
                                raceInfos[i].lastHeel = gRecords[r][i].heel;
                                raceInfos[i].lastDampTwd = gRecords[r][i].dampTwd;
                                raceInfos[i].lastTwaTgt = gRecords[r][i].twaTgt;
                                raceInfos[i].lastXName = gRecords[r][i].xName;

                                // xHdm and xDist are not always valid
                                if ( !isNaN(gRecords[r][i].xHdm) && gRecords[r][i].xHdm !== 999999 )
                                    raceInfos[i].lastXHdm = gRecords[r][i].xHdm;
                                if ( !isNaN(gRecords[r][i].xDist) && gRecords[r][i].xDist > 0 )
                                    raceInfos[i].lastXDist = gRecords[r][i].xDist;

                                latMin = Math.min(latMin, raceInfos[i].lastLat);
                                latMax = Math.max(latMax, raceInfos[i].lastLat);
                                lonMin = Math.min(lonMin, raceInfos[i].lastLon);
                                lonMax = Math.max(lonMax, raceInfos[i].lastLon);
                            }
                        }
                    }

                    // The demo race records have bad race times, fix these here
                    if ( demo )
                    {
                        for ( var i=0; i<raceInfos.length; i++ )
                        {
                            gRecords[r][i].racetime = r - 359;
                        }
                    }

                    // Check if the leg counts need adjustment and fill the leg index into each gRecord
                    for ( var i = 0; i<raceInfos.length; i++ )
                    {
                        if ( gRecords[r][i].racetime >= 0 )
                        {
                            // If we don't have marks, extract them from for each boat record
                            if ( raceInfos[i].loggedMarkList.length === 0 )
                            {
                                if ( raceInfos[i].legXMark == null )
                                {
                                    if ( gRecords[r][i].xName !== undefined
                                         && gRecords[r][i].xName !== null
                                         && gRecords[r][i].xName.length > 1 )
                                    {
                                        // First time we have an xmark value for this boat
                                        raceInfos[i].legXMark = gRecords[r][i].xName;
                                        raceInfos[i].constructedMarkList.push( {index: 1, name: gRecords[r][i].xName, roundingRaceTime: 0});
                                        console.log('Setting first mark for boat ' + i + ' to ' + gRecords[r][i].xName);
                                    }
                                }
                                else
                                {
                                    // Check if the next mark changed
                                    if ( gRecords[r][i].xName !== undefined
                                         && gRecords[r][i].xName !== null
                                         && gRecords[r][i].xName.length > 1
                                         && gRecords[r][i].xName !== raceInfos[i].legXMark )
                                    {
                                        raceInfos[i].legIdx++;
                                        raceInfos[i].legXMark = gRecords[r][i].xName;
                                        raceInfos[i].constructedMarkList[raceInfos[i].constructedMarkList.length-1].roundingRaceTime = gRecords[r][i].racetime;
                                        raceInfos[i].constructedMarkList.push( {index: raceInfos[i].legIdx + 1, name: gRecords[r][i].xName, roundingRaceTime: 0});
                                        console.log('Changing next mark for boat ' + i + ' to ' + gRecords[r][i].xName + ' | ' + raceInfos[i].legIdx + ' at time ' + gRecords[r][i].racetime);
                                    }
                                }
                            }
                            else // ... otherwise use the rounding times of this boat's mark list
                            {
                                if ( raceInfos[i].loggedMarkList.length > raceInfos[i].legIdx
                                     &&
                                     gRecords[r][i].racetime > raceInfos[i].loggedMarkList[raceInfos[i].legIdx].roundingRaceTime )
                                {
                                    raceInfos[i].legIdx++;
                                    console.log('Changing next mark for boat ' + i + ' to ' + (raceInfos[i].legIdx < raceInfos[i].loggedMarkList.length ? raceInfos[i].loggedMarkList[raceInfos[i].legIdx].name : 'n/a') + ' | ' + raceInfos[i].legIdx + ' at time ' + gRecords[r][i].racetime);
                                }
                            }
                        }
                        gRecords[r][i].legIdx = raceInfos[i].legIdx;
                    }

                    //console.log(gRecords[r][0].race_id + ' | ' + gRecords[r][0].rtime + ' - ' + gRecords[r][1].race_id + ' | ' + gRecords[r][1].rtime);
                }

                // Check if we need to assign any constructed mark lists
                for ( var i = 0; i<raceInfos.length; i++ )
                {
                    if ( raceInfos[i].loggedMarkList.length === 0 && raceInfos[i].constructedMarkList.length > 0 )
                    {
                        for ( var j=0; j<raceInfos[i].constructedMarkList.length; j++ )
                        {
                            if ( raceInfos[i].constructedMarkList[j].hasOwnProperty('name') && raceInfos[i].constructedMarkList[j]['name']
                                 && raceInfos[i].constructedMarkList[j].hasOwnProperty('lat') && raceInfos[i].constructedMarkList[j]['lat']
                                 && raceInfos[i].constructedMarkList[j].hasOwnProperty('lon') && raceInfos[i].constructedMarkList[j]['lon']
                                 && raceInfos[i].constructedMarkList[j].hasOwnProperty('roundingRaceTime') && raceInfos[i].constructedMarkList[j]['roundingRaceTime'] )
                            {
                                raceInfos[i].loggedMarkList.push( raceInfos[i].constructedMarkList[j] );
                            }
                            else
                            {
                                console.log("Ignoring incomplete mark:");
                                console.log(raceInfos[i].constructedMarkList[j]);
                            }
                        }
                    }
                }

                // If a boat has no finish or a mark close to the end, append a finish so that the legs look correct.
                for ( var i = 0; i<raceInfos.length; i++ )
                {
                    var startIsFinish = (Math.abs(gRecords[gNumRecords - 2][i].lat - raceInfos[i].startBoatLat) < 0.0045
                                         && Math.abs(gRecords[gNumRecords - 2][i].lon - raceInfos[i].startBoatLon) < 0.0045);

                    if ( raceInfos[i].loggedMarkList.length === 0 )
                    {
                        // Just append the finish
                        raceInfos[i].loggedMarkList.push(
                            {
                                index: 1,
                                name: (startIsFinish ? '' : 'Finish'),
                                lat: gRecords[gNumRecords - 2][i].lat,
                                lon: gRecords[gNumRecords - 2][i].lon,
                                roundingRaceTime: gRecords[gNumRecords - 2][i].racetime
                            });
                    }
                    else
                    {
                        var endDelta = gRecords[gNumRecords - 2][i].racetime - raceInfos[i].loggedMarkList[raceInfos[i].loggedMarkList.length - 1].roundingRaceTime;
                        if ( endDelta > 60
                             &&
                             raceInfos[i].loggedMarkList[raceInfos[i].loggedMarkList.length - 1].name !== 'Finish' )
                        {
                            var idx = raceInfos[i].loggedMarkList[raceInfos[i].loggedMarkList.length - 1].index + 1;
                            raceInfos[i].loggedMarkList.push(
                                {
                                    index: idx,
                                    name: (startIsFinish ? '' : 'Finish'),
                                    lat: gRecords[gNumRecords - 2][i].lat,
                                    lon: gRecords[gNumRecords - 2][i].lon,
                                    roundingRaceTime: gRecords[gNumRecords - 2][i].racetime
                                });
                        }
                    }
                }

                // Now that we have as-good-as-it-gets marklists, set the stops on the timeline
                updateTimelineStopsForSelectedBoatIdx( gSelectedBoatIndex );

                // Calculate play times for regular races (same start time for all boats)
                if ( raceInfos[0].regattaType !== 2 )
                {
                    // Regular race
                    for ( var i = 0; i < raceInfos.length; i++ )
                    {
                        gRaceStartOffset.push(0);
                    }
                    gRaceDuration = gRecords[gNumRecords - 1][gSelectedBoatIndex].rtime / 100.0 - gRaceStartTime;
                }

                console.log("SailCast: Found " + gNumRecords + " records for race");
                console.log("SailCast: Race started at " + gRaceStartTime + " and lasted " + gRaceDuration + " seconds");

                gotRaceData = true;

                gGeoBox = getBoundingGeoBox();
                gBoatChaseDistance = kCameraPlaneChaseDistance * 178.0 / gLatScale;

                loadGeoMap(gGeoBox.ctrLat, gGeoBox.ctrLon, gGeoBox.mapZoom, demo);

                ///layoutPlayerView();

                checkForLoadingCompleted();

                gAllLogsLoaded = true;

                if ( !gMarksLoaded )
                {
                    loadCourseMarks(gScene);
                }

                // On iPads / iPhone scroll down by the top bar size and hide side bar to maximize viewing area
                scrollViewForMobile();
            }
        }

        if ( !gotRaceData )
        {
            var alertDiv = document.getElementById('no-race-data-alert');
            alertDiv.style.display = 'block';
        }
    });
}

/* ==============================================================
   MEDIA PHOTO STREAM MASONRY
   ============================================================== */

/*** UNUSED FOR NOW
function mediaInitializeMasonry()
{
    if ( mediaStreamNumPhotos === 0 ) return;

    var rootElements = document.getElementsByClassName('masonry-root');
    gMediaRoots = Array.prototype.map.call(rootElements, function(rootElement) {
        var cellElements = rootElement.getElementsByClassName('masonry-cell');
        var cells = Array.prototype.map.call(cellElements, function(cellElement) {
            var style = getComputedStyle(cellElement);
            return {
                'element': cellElement,
                'outerHeight': parseInt(style.marginTop) + cellElement.offsetHeight + parseInt(style.marginBottom)
            };
        });
        return {
            'element': rootElement,
            'noOfColumns': 1,
            'cells': cells
        };
    });

    // Do the first layout
    mediaLayoutMasonry();
}

function mediaLayoutMasonry()
{
    if ( mediaStreamNumPhotos === 0 ) return;

    for ( var i=0; i<gMediaRoots.length; i++ )
    {
        // Only layout when the number of columns has changed
        var newNoOfColumns = 1; //Math.floor(root.element.offsetWidth / gMediaMinColWidth);
        if ( newNoOfColumns !== gMediaRoots[i].noOfColumns )
        {
            // Initialize
            gMediaRoots[i].noOfColumns = newNoOfColumns;
            var columns = Array.from(new Array(gMediaRoots[i].noOfColumns)).map( function(column) {
                return {
                    'cells': new Array(),
                    'outerHeight': 0
                };
            });

            // Divide...
            for ( var k=0; k<gMediaRoots[i].cells.length; k++ )
            {
                var minOuterHeight = Math.min(...columns.map( function(column) {
                    return column.outerHeight;
                }));
                var column = columns.find( function(column) {
                    return (column.outerHeight === minOuterHeight);
                });
                column.cells.push(gMediaRoots[i].cells[k]);
                column.outerHeight += gMediaRoots[i].cells[k].outerHeight;
            }

            // calculate masonry height
            var masonryHeight = Math.max(...columns.map( function(column) {
                return column.outerHeight;
            }));

            // ...and conquer
            var order = 0;
            for ( var j=0; j<columns.length; j++ )
            {
                for ( var l=0; l<columns[j].cells.length; l++ )
                {
                    columns[j].cells[l].element.style.order = order++;
                    // set the cell's flex-basis to 0
                    columns[j].cells[l].element.style.flexBasis = 0;
                }
                // set flex-basis of the last cell to fill the
                // leftover space at the bottom of the column
                // to prevent the first cell of the next column
                // to be rendered at the bottom of this column
                columns[j].cells[columns[j].cells.length - 1].element.style.flexBasis = columns[j].cells[columns[j].cells.length - 1].element.offsetHeight + masonryHeight - columns[j].outerHeight - 1 + 'px';
            }

            // set the masonry height to trigger
            // re-rendering of all cells over columns
            // one pixel more than the tallest column
            gMediaRoots[i].element.style.maxHeight = masonryHeight + 1 + 'px';

            console.log(columns.map( function(column) {
                return column.outerHeight;
            }));
            console.log(root.element.style.maxHeight);
        }
    }
}
 ***/

/* ==============================================================
   HELPER FUNCTIONS
   ============================================================== */
function getBoundingGeoBox()
{
    var minLat = 90;
    var minLon = 180;
    var maxLat = -90;
    var maxLon = -180;

    // Make sure all marks are accounted for
    for ( var i=0; i<gMarks.length; i++ )
    {
        if ( !isNaN(gMarks[i].lat) && gMarks[i].lat != 0 && !isNaN(gMarks[i].lon) && gMarks[i].lon != 0 )
        {
            minLat = Math.min(minLat, gMarks[i].lat);
            maxLat = Math.max(maxLat, gMarks[i].lat);
            minLon = Math.min(minLon, gMarks[i].lon);
            maxLon = Math.max(maxLon, gMarks[i].lon);
        }
    }

    // Make sure all boat positions are accounted for
    for ( var i=0; i<gNumRecords; i+= 15 )
    {
        for ( var j=0; j<numBoats; j++ )
        {
            if ( !isNaN(gRecords[i][j].lat) && gRecords[i][j].lat != 0 && !isNaN(gRecords[i][j].lon) && gRecords[i][j].lon != 0 )
            {
                minLat = Math.min( minLat, gRecords[i][j].lat );
                maxLat = Math.max( maxLat, gRecords[i][j].lat );
                minLon = Math.min( minLon, gRecords[i][j].lon );
                maxLon = Math.max( maxLon, gRecords[i][j].lon );
            }
        }
    }

    centerLat = minLat + (maxLat - minLat) / 2.0;
    centerLon = minLon + (maxLon - minLon) / 2.0;

    // Find the longer side of the geo-box
    var latDelta = maxLat - minLat;
    var lonDelta = maxLon - minLon;

    // The box size is in latitudinal degrees
    var geoBoxSize = Math.max( latDelta, lonDelta * Math.cos( centerLat * kDegToRad ) );

    // Convert latitudinal degrees into a Google maps zoom factor
    // We retrieve the max. size for static gmaps at 640x640:
    var scale = geoBoxSize * 1852.0 / 640.0;
    var gmapZoom = Math.floor(8.0 - Math.log2(scale)) + 2;

    // Get the actual corner coordinates based on our center and gmap tiles
    var mapRegion = guGetGmapCorners( {lat: centerLat, lon: centerLon}, gmapZoom, 640, 640);
    minLat = mapRegion.sw.lat;
    maxLat = mapRegion.ne.lat;
    minLon = mapRegion.sw.lon;
    maxLon = mapRegion.ne.lon;

    // Update our box size to the gmap zoom step
    latDelta = maxLat - minLat;
    lonDelta = maxLon - minLon;
    geoBoxSize = Math.max( latDelta, lonDelta * Math.cos( centerLat * kDegToRad ) );

    // Make the box 3x the size to make sure we always cover the horizon
    // from the render perspective
    ///minLat = centerLat - 1.5 * geoBoxSize;
    ///maxLat = centerLat + 1.5 * geoBoxSize;
    ///minLon = centerLon - 1.5 * geoBoxSize / Math.cos( centerLat * kDegToRad );
    ///maxLon = centerLon + 1.5 * geoBoxSize / Math.cos( centerLat * kDegToRad );

    gLatScale = 1.0 / (geoBoxSize / kOceanSize);
    gLonScale = 1.0 / ((geoBoxSize / Math.cos( centerLat * kDegToRad )) / kOceanSize);

    gBoatTrailInterval = Math.max( 33.0 - 0.045 * gLatScale, 5 );

    return { minLat: minLat, minLon: minLon, maxLat: maxLat, maxLon: maxLon, ctrLat: centerLat, ctrLon: centerLon, mapZoom: gmapZoom };
}

function translate( lat, lon )
{
    return { x: (lon - centerLon) * gLonScale, y: (lat - centerLat) * gLatScale };
}

function getViewportCoordinates( location )
{
    var zOffset = (gCameraMode == kCameraModeChase ? 0.17 : 0.0);

    gVector.set( location.x, location.y, location.z + zOffset );
    gVector.project( gCamera );

    gVector.x = (gVector.x + 1)/2 * $('#scene').width();
    gVector.y = -(gVector.y - 1)/2 * $('#scene').height();

    return gVector;
}

function checkForLoadingCompleted()
{
    if ( gAllElementsLoaded && gAllLogsLoaded && gGeoTexturesLoaded && gOceanTexturesLoaded )
    {
        layoutContainer();
        layoutPlayerView();
        setTimeout( function() { layoutScrubberTimeline(); }, 1000 );

        // In demo mode start in upwind view
        if ( gDemoMode ) gCameraMode = kCameraModeBevGeo;

        toggleCameraMode();

        // Show helper for camera toggle
        var helper = document.getElementById('cam-toggle-helper');
        helper.style.display = 'block';
        setTimeout( function() {
            helper.style.opacity = 1.0;
            setTimeout(function () {
                helper.style.opacity = 0.0;
            }, 5000);
        }, 1000 );

        replayResume();
    }
    else
    {
        setTimeout( function() {
            checkForLoadingCompleted();
        }, 250 );
    }
}

function showShareLinkModal( id )
{
    $("body").ufModal({
        sourceUrl: site.uri.public + "/modals/sailcast/share-link?id=" + id + (originatorIsApp === 1 ? '&m=1' : ''),
        msgTarget: $("#alerts-page")
    });

    attachShareLinkForm( id );
}

function attachShareLinkForm( raceId )
{
    $("body").on('renderSuccess.ufModal', function (data) {
        var modal = $(this).ufModal('getModal');
        modal.css( 'z-index', '10000' );
        var form = modal.find('.js-form');
        // Set up the form for submission
        form.ufForm({
            validators: page.validators
        }).on("submitSuccess.ufForm", function() {
            // Reload page on success
            window.location.reload();
        });
    });
}